function setupAccordions() {
    $('.accordion__title').click(function (e) {
        e.preventDefault();

        if ($('.accordion__txt').is(':animated')) {
            return false;
        }

        var $title = $(this);
        var $openAccordion = $('.accordion--open');

        if ($openAccordion.length > 0) {
            $openAccordion.removeClass('accordion--open');
            $openAccordion.find('.accordion__txt').hide();
        }

        if ($openAccordion.get(0) != $title.parent().get(0)) {
            $title.parent().addClass('accordion--open');
            $title.next().show();
        }
    });
}

$(document).ready(function(){
    setupAccordions();
});


;(function ($) {
    $.fn.ajaxForm = function (options) {
        return this.filter('form').each(function () {
            var form = this;
            var $form = $(form);

            var settings = $.extend({
                data: $form.serialize(),
                method: $form.attr('method'),
                url: $form.attr('action')
            }, options);

            $form.on('submit', function (e) {
                e.preventDefault();
                $.ajax(settings);
            });
        });
    };
})(jQuery);

var ajaxFormProcessing = false;

handleAjaxForms();

function handleAjaxForms() {
    $('.ajax-form').each(function () {
        var $wrapper = $(this);
        var $form = $wrapper.find('.ajax-form__form');

        $form.on('submit', function (e) {
            if ($form.valid() && ajaxFormProcessing === false) {
                ajaxFormProcessing = true;

                var jqXHR = $.ajax({
                    type: $form.attr('method'),
                    url: $form.attr('action'),
                    data: $form.serialize(),
                    dataType: 'json',
                    beforeSend: function () {
                        $form.addClass('ajax-form__form--loading');
                        $form.find('.error').removeClass('error');
                        $form.find('.msg-error').remove();
                    },
                    statusCode: {
                        422: function (jqXHR) {
                            $.each(jqXHR.responseJSON, function (field, errors) {
                                // Converts dot-delimited strings (foo.bar) to
                                // HTML input format (foo[bar]).
                                var field = field.replace(/\.(\w+)/g, '[$1]');

                                var $input = $form.find('[name="' + field + '"]');

                                if (! $input.hasClass('error')) {
                                    var $formRow = $input.closest('.form-row');
                                    $formRow.addClass('form-row--error');
                                    $input.addClass('error');
                                    $.each(errors, function (index, error) {
                                        // $formRow.append('<div class="msg-error msg-error--red-text">' + error + '</div>');
                                    });
                                }
                            });
                        }
                    }
                });

                jqXHR.done(function (data) {
                    // Wrapping this in an if() statement because this
                    // callback gets called even if the request WASN’T
                    // successful, as it relies on the result of data.status
                    // and not the HTTP status code.
                    if (typeof data.status !== 'undefined') {
                        if (data.status === 1) {
                            $form.hide();
                            $wrapper.find('.ajax-form__thank-you').show();
                            $('.ajax-form__elem--hide-on-completion').hide();
                            $('.ajax-form__elem--show-on-completion').show();

                            if ($form.find('.stages__steps__step--selected').length > 0) {
                                completeSteps($form.closest($('.stages')));
                            }

                            if (typeof data.redirect !== 'undefined' && data.redirect !== '') {
                                setTimeout(function() {
                                    window.location = data.redirect;
                                }, 5000);
                            }

                            if (typeof data.reload !== 'undefined' && data.reload) {
                                setTimeout(function() {
                                    window.location.reload();
                                }, 5000);
                            }
                        } else {
                            if (typeof data.formError !== 'undefined' && data.formError !== '') {
                                var message = '';

                                if (typeof data.formError == 'object') {
                                    $.each(data.formError, function(index, errors) {
                                        message += index+':';

                                        $.each(errors, function(i, error) {
                                            message += ' '+error+' ';
                                        });
                                    });
                                } else {
                                    message = data.formError;
                                }

                                $form.prepend('<ul class="msg-error msg-error--red-text ajax-form__errors">'+ $.trim(message)+'</ul>');
                            }

                            if (typeof data.fieldErrors !== 'undefined') {
                                for (var i in data.fieldErrors) {
                                    $('[name="'+data.fieldErrors[i]+'"]').addClass('error');
                                }
                            }
                        }
                    }
                });

                jqXHR.fail(function (jqXHR, textStatus, errorThrown) {
                    var ajaxFormErrors = '';

                    if (jqXHR.responseJSON) {
                        $.each(jqXHR.responseJSON, function (key, errors) {
                            $.each(errors, function (index, error) {
                                var $input = $form.find('[name="' + key + '"]');

                                if ($input.length > 0) {
                                    if (! $input.hasClass('error')) {
                                        $input.addClass('error').closest('.form-row')
                                            .addClass('form-row--error')
                                            .append('<div class="msg-error msg-error--red-text">' + error + '</div>');
                                    }
                                } else {
                                    ajaxFormErrors += '<li>' + error + '</li>';
                                }
                            });
                        });
                    } else {
                        ajaxFormErrors += '<li>There has been an unexpected error, please try again</li>';
                    }

                    $form.prepend('<ul class="msg-error msg-error--red-text ajax-form__errors">'+ajaxFormErrors+'</ul>');
                });

                jqXHR.always(function(data, textStatus) {
                    if (typeof window[$form.data('callback')] === 'function') {
                        window[$form.data('callback')]($form, data);
                    }

                    ajaxFormProcessing = false;
                    $form.removeClass('ajax-form__form--loading');
                });
            }

            e.preventDefault();
        });
    });
}

function ajaxFormHasErrors($form)
{
    return $form.parent().find('.ajax-form__errors').length > 0;
}

function ajaxFormReset($form)
{
    $form.get(0).reset();

    var $select = $form.find('select');

    if ($select.length > 0) {
        $select.data('selectBox-selectBoxIt').refresh();
    }
}

function ajax_form_callback_request_an_access_code() {
    var axel = Math.random() + "";
    var a = axel * 10000000000000;

    $('body').append('<iframe src="https://5188062.fls.doubleclick.net/activityi;src=5188062;type=leads;cat=partn0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=1;num=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>');
}

function ajax_form_callback_login(form, data) {
    ajax_form_callback_login_register(form, data);
}

function ajax_form_callback_abuse_report(form, data) {
    $('.error-message-container').empty();
    $('.success-message-container').html('<li>' + data.message + '</li>');
}

function ajax_form_callback_register(form, data) {
    ajax_form_callback_login_register(form, data);
}

function ajax_form_callback_create_contact(form, data) {
    var $form = $(form);

    // Remove any previously-set error classes
    $form.find('.form-row--error').removeClass('form-row--error');
    $form.find('.error').removeClass('error');
    $form.find('.js-validation-error').remove();

    if (data.responseJSON.status) {
        if (data.responseJSON.status === 1) {
            closeModal();

            $('.ajax-update-contacts-select').data('selectBox-selectBoxIt').add({
                value: data.responseJSON.contact.uuid,
                text: data.responseJSON.contact.firstName+' '+data.responseJSON.contact.lastName
            });

            $('.ajax-update-contacts-list').append('<li class="js-select-hide-additional-contact additional-contact-'+data.responseJSON.contact.uuid+'"> \
                <div class="checkbox"> \
                    <input type="checkbox" name="additional_contacts[]" id="frm-additional-contacts-'+data.responseJSON.contact.uuid+'" value="'+data.responseJSON.contact.uuid+'" /> \
                    <label for="frm-additional-contacts-'+data.responseJSON.contact.uuid+'">'+data.responseJSON.contact.firstName+' '+data.responseJSON.contact.lastName+'</label> \
                </div> \
            </li>');
        } else if (data.responseJSON.status === 0) {
            if (data.responseJSON.message) {
                $(form).prepend('<p style="color:red;text-align:center;" class="js-validation-error">'+data.responseJSON.message+'</p>');
            }

            if (data.responseJSON.validationErrors) {
                $.each(data.responseJSON.validationErrors, function(fieldName, errorArray) {
                    var $input = $(form).find('input[name="'+fieldName+'"]');
                    var $formRow = $input.closest('.form-row');
                    $formRow.addClass('form-row--error');
                    $input.addClass('error');
                    $.each(errorArray, function (index, error) {
                        $formRow.append('<p style="color:red;text-align:center;margin-top:5px;" class="js-validation-error">'+error+'</p>');
                    });
                });
            }
        }
    } else {
        if (data.status != 201) {
            // Laravel validation error
            $.each(data.responseJSON, function(field, errors) {
                var $input = $(form).find('input[name="' + field + '"]');
                var $formRow = $input.closest('.form-row');
                $formRow.addClass('form-row--error');
                $input.addClass('error');
                $.each(errors, function (index, error) {
                    $formRow.append('<p style="color:red;text-align:center;margin-top:5px;" class="js-validation-error">' + error + '</p>');
                });
            });
        }
    }
}

function add_contact_from_service_manager($form, user) {
    if (! ajaxFormHasErrors($form)) {
        if (typeof user.firstName != 'undefined') {
            var userName = user.firstName + ' ' + user.lastName;
            var uuid = user.uuid;

            $('select.owner').each(function () {
                $(this).selectBoxIt();
                $(this).data('selectBox-selectBoxIt').add({
                    value: uuid,
                    text: userName
                });
            });
        }

        closeModal($('.modal').filter(':visible'));
    }
}

function ajax_form_callback_reload_page() {
    window.location.reload();
}

function ajax_form_callback_login_register(form, data) {
    var authorised;

    if (data.responseJSON) {
        authorised = data.responseJSON.authorised;
    } else {
        authorised = data.authorised;
    }

    if (authorised) {
        $('.error-message-container').empty();

        closeModal();

        if (form.data('auth-callback-function') && typeof window[form.data('auth-callback-function')] === 'function') {
            window[form.data('auth-callback-function')]();
        } else {
            var anchor = $('.ajax-form-login-register-reload-anchor').attr('id');

            if (typeof anchor != 'undefined' && anchor != 'comments') {
                window.location = window.location.pathname + window.location.search + '#' + anchor;
            } else if (data['return']) {
                window.location = data['return'];
            } else {
                ajax_form_callback_reload_page();
            }
        }
    } else {
        var message = '';

        if (data.responseJSON && data.responseJSON.message) {
            message += data.responseJSON.message;
        } else if (data.message) {
            message += data.message;
        }

        if (message != '') {
            $('.error-message-container').empty().append('<li>' + message + '</li>');
        }
    }
}

function ajax_form_callback_contract_signed($form, data)
{
    $('body').find('.download-contract-button').hide();
}

function ajax_form_callback_contact_us($form, data)
{
    if (data.status === 1) {
        $('body').find('.help').hide();
    }
}

var ajaxLoadContentProcessing = false;

$('body').on('click', '.ajax-load-content', function(e) {
    e.preventDefault();

    var $btn = $(this);
    var loadInto = $btn.data('load-into');
    var tabs = $btn.data('tabs');

    if (typeof tabs !== 'undefined') {
        var $tabs = $(tabs);

        if ($tabs.length > 0) {
            if ($btn.closest(tabs+'__active').length > 0) {
                $tabs.toggleClass('open');

                return false;
            }

            $tabs.removeClass('open');
        }
    }

    if (ajaxLoadContentProcessing === false) {
        ajaxLoadContentProcessing = true;
        $.ajax({
            type: 'GET',
            url: $btn.attr('href'),
            dataType: 'html',
            beforeSend: function() {
                addLoading('blue loading--bg-white');
            },
            success: function(data) {
                var $data = $(data);

                $(loadInto).html($data.find(loadInto).html());

                formsSetup();
                picturefill();
            }
        }).complete(function(data) {
            if (typeof window[$btn.data('callback')] === 'function') {
                window[$btn.data('callback')]($btn, data);
            }

            ajaxLoadContentProcessing = false;
            removeLoading();
        });
    }
});

var ajaxLoadMoreProcessing = false;

$('body').on('click', '.ajax-load-more', function (e) {
    var $btn = $(this);
    var loadInto = $btn.data('load-into');

    if (ajaxLoadMoreProcessing === false) {
        ajaxLoadMoreProcessing = true;
        $.ajax({
            type: 'GET',
            url: $btn.attr('href'),
            dataType: 'html',
            success: function (data) {
                var $data = $(data);
                var $newBtn = $data.find('.ajax-load-more[data-load-into="'+loadInto+'"]');
                var $target = $(loadInto);

                $target.append($data.find(loadInto).html());

                if ($newBtn.length === 0) {
                    $btn.remove();
                } else {
                    $btn.attr('href', $newBtn.attr('href'));
                }

                picturefill();
                equalise();

                $target.find('.dotdotdot').dotdotdot();
            }
        }).complete(function (data) {
            if (typeof window[$btn.data('callback')] === 'function') {
                window[$btn.data('callback')]($btn, data);
            }

            ajaxLoadMoreProcessing = false;
        });
    }

    e.preventDefault();
});

$('document').ready(function() {
    let navlinks = document.querySelectorAll('.alt-nav-link')

    for (let i = 0; i < navlinks.length; i++) {
        navlinks[i].addEventListener('click', (e) => handleNavLinkClick(e))
    }

    function handleNavLinkClick(e) {
        e.preventDefault()
        let navLink = e.target
        let dropdown = e.target.nextElementSibling
        if (!dropdown.classList.contains('open-alt-dropdown')) {
            closeAltDropdowns()
        }
        if(!navLink.classList.contains('active')) removeActive()
        
        navLink.classList.toggle('active')
        dropdown.classList.toggle('open-alt-dropdown')
    }

    function removeActive() {
        for (let i = 0; i < navlinks.length; i++) {
            navlinks[i].classList.remove('active')
        }
    }

    function closeAltDropdowns() {
        let dropdowns = document.querySelectorAll('.alt-nav-link + ul')
        dropdowns.forEach((dropdown) => {
            dropdown.classList.remove('open-alt-dropdown')
        })
    }

    $('body').on('click', function(e){
        if (!e.target.classList.contains('ignore')) {
            closeAltDropdowns()
            removeActive()
        }
    })
})
$('.js-autoload-content').each(function() {
    var $elem = $(this);

    $.ajax({
        url: $elem.data('url'),
        success: function(data) {
            $elem.html($(data).find('#'+$elem.attr('id')).html());

            formsSetup();
            picturefill();

            if (typeof window[$elem.data('callback')] === 'function') {
                window[$elem.data('callback')]($elem);
            }
        }
    });
});

var isUnsavedForm = false;

function catchUnsavedForm()
{
    $('.js-catch-unsaved-form').each(function() {
        var $form = $(this);

        $form.data('original', $form.serialize());
    });

    $('body')
        .on('change', '.js-catch-unsaved-form', function(e) {
            var $form = $(this);

            if ($form.serialize() != $form.data('original')) {
                isUnsavedForm = true;
            }
        })
        .on('click', 'a', function(e) {
            if (isUnsavedForm) {
                var $link = $(this);
                var href = $link.attr('href');
                var showModal = true;

                if (href == 'javascript:;' || href.substr(0, 1) == '#') {
                    showModal = false;
                } else if ($link.hasClass('js-catch-unsaved-form-ignore') || $link.hasClass('js-toggle-dropdown') || $link.hasClass('js-nav-personal') || $link.hasClass('js-nav-business') || $link.hasClass('open-modal')) {
                    showModal = false;
                } else if ($link.attr('target') == '_blank') {
                    showModal = false;
                }

                if (showModal) {
                    var modalId = openModal($('body').data('catch-unsaved-form'));

                    $(modalId).data('continue-url', href);

                    e.preventDefault();
                }
            }
        })
        .on('submit', '.search-dropdown-form', function(e) {
            if (isUnsavedForm) {
                var modalId = openModal($('body').data('catch-unsaved-form'));

                $(modalId).data('continue-form', '.search-dropdown-form');

                e.preventDefault();
            }
        })
        .on('click', '.js-catch-unsaved-form-continue', function(e) {
            var url = $(this).closest('.modal').data('continue-url');
            var form = $(this).closest('.modal').data('continue-form');

            if (typeof url != 'undefined' && url != '') {
                window.location = url;
            } else if (typeof form != 'undefined' && form != '') {
                isUnsavedForm = false;

                $(form).trigger('submit');
            }

            e.preventDefault();
        });
}

$('.category-icons__category--interaction > a').click(function(e) {
    if ($('.category-icons__sub-categories--open').is(':animated')) {
        e.preventDefault();

        return false;
    }

    var $this = $(this);
    var $subCategoriesWrapper = $this.closest('.core').next();
    var isMobile = $('body').hasClass('device-mobile');

    if ($this.hasClass('open') || !$subCategoriesWrapper.hasClass('category-icons__sub-categories--open')) {
        $('.category-icons__sub-categories--open').removeClass('category-icons__sub-categories--open').slideUp(function() {
            if (isMobile) {
                $('html, body').animate({scrollTop: $this.offset().top - 50});
            }
        });
    }

    if ($this.hasClass('open')) {
        $this.removeClass('open');
    } else {
        $('.category-icons__category > a.open').removeClass('open');
        $this.addClass('open');

        $subCategoriesWrapper.find('.core').html('<a href="javascript:;" class="category-icons__sub-categories__close js-category-icons-close-sub-categories"><i class="icon-cross2"></i></a><ul>'+$this.closest('li').find('.category-icons__category__sub-categories').html()+'</ul>');
        $subCategoriesWrapper.find('ul').cleanWhitespace();
        $subCategoriesWrapper.slideDown(function() {
            $subCategoriesWrapper.addClass('category-icons__sub-categories--open');
        });
    }

    e.preventDefault();
});

$('.lt-ie9').on('mouseenter', '.category-icons__category__sub-category > a', function() {
    var $products = $(this).closest('li').find('.category-icons__category__sub-category__products');

    $products.css({
        marginTop: -$products.outerHeight(),
        marginLeft: -$products.outerWidth() / 2
    });
});

$('body').on('click', '.js-category-icons-close-sub-categories', function(e) {
    $('.category-icons__category > a.open').removeClass('open');
    $('.category-icons__sub-categories--open').removeClass('category-icons__sub-categories--open').slideUp();

    e.preventDefault();
});

;(function ($) {
    $('.js-collapse-toggle').on('click', function (e) {
        e.preventDefault();

        var $btn = $(this);
        var $target = $($btn.attr('href'));

        $btn.toggleClass('is-open');
        $target.toggleClass('open');
    });
})(jQuery);

var commentsFormProcessing = false;
var replyFormProcessing = false;
var totalComments = 0;
var totalCommentsDisplayed = 0;
var totalReplies = [];
var totalRepliesDisplayed = [];
var triggerModalClose = false;

initComments();

function initComments() {
    var $wrapper = $('.comments-form');
    var $form = $wrapper.find('.comments-form__form');
    var $list = $wrapper.find('.comments-list');
    var $loadMoreComments = $list.find('.load-more-comments');
    totalComments = $list.data('total');
    totalCommentsDisplayed = $list.data('displayed');

    initReplyTotals($list, null);

    $form.submit(function (e) {
        var $form = $(this);

        if ($form.valid() && commentsFormProcessing === false) {
            commentsFormProcessing = true;
            $.ajax({
                type: $form.attr('method'),
                url: $form.attr('action'),
                data: $form.serialize(),
                dataType: 'json',
                beforeSend: function () {
                    $form.css({'opacity': '0.7'});
                },
                success: function (data) {
                    if (typeof data.authorised !== 'undefined') {
                        if (!data.authorised && data.auth_url != '') {
                            openModal(data.auth_url);
                            triggerModalClose = true;
                        } else if (data.authorised) {
                            if (triggerModalClose) {
                                closeModal();
                                triggerModalClose = false;
                            }

                            addCommentToList($wrapper, $list, data.comment);
                        }
                    }
                }
            }).complete(function (data) {
                commentsFormProcessing = false;
                $form.css({'opacity': '1'});
            });
        }

        e.preventDefault();
    });

    initCommentButtons($list);
    initReplies($wrapper, $list, null);

    $loadMoreComments.off('click').click(function () {
        updateComments($wrapper, $list, $(this), $form.data('list'));

        return false;
    });
}

function initReplyTotals($list, uuid) {
    if (uuid) {
        totalRepliesDisplayed[uuid] = 0;

        if (!totalReplies[uuid]) {
            totalReplies[uuid] = $list.find('.comment[data-is-reply=0][data-uuid="'+uuid+'"]').data('total-replies');
        }

        $($list.find('.comment[data-is-reply=1][data-uuid="'+uuid+'"]')).each(function () {
            totalRepliesDisplayed[uuid]++;
        });
    } else {
        $($list.find('.comment[data-is-reply=0]')).each(function () {
            var uuid = $(this).data('uuid');

            if (!totalReplies[uuid]) {
                totalReplies[uuid] = $(this).data('total-replies');
            }

            totalRepliesDisplayed[uuid] = 0;

            $($list.find('.comment[data-is-reply=1][data-uuid="'+uuid+'"]')).each(function () {
                totalRepliesDisplayed[uuid]++;
            });
        });
    }
}

function initReplies($wrapper, $list, url) {
    $($list.find('.reply-form')).each(function () {
        var $replyForm = $(this);
        var $url = $replyForm.attr('action');
        var uuid = $replyForm.data('parent-uuid');

        if (url) {
            $url = url;
        }

        $replyForm.submit(function (e) {
            if ($replyForm.valid() && replyFormProcessing === false) {
                replyFormProcessing = true;

                $.ajax({
                    type: $replyForm.attr('method'),
                    url: $url,
                    data: $replyForm.serialize(),
                    dataType: 'json',
                    beforeSend: function () {
                        $replyForm.css({'opacity': '0.7'});
                    },
                    success: function (data) {
                        if (typeof data.authorised !== 'undefined') {
                            if (!data.authorised && data.auth_url != '') {
                                openModal(data.auth_url);
                            } else if (data.authorised) {
                                closeModal();
                                addReplyToList($wrapper, $list, $replyForm, uuid, data.comment);
                            }
                        }
                    }
                }).complete(function (data) {
                    replyFormProcessing = false;
                    $replyForm.css({'opacity': '1'});
                });
            }

            e.preventDefault();
        });
    });

    var $loadMoreReplies = $list.find('.load-more-replies');

    $loadMoreReplies.off('click').click(function () {
        updateReplies($wrapper, $list, $(this), $(this).data('list'));

        return false;
    });
}

function initCommentButtons($list) {
    $($list.find('.reply-btn')).each(function () {
        $(this).click(function () {
            $(".reply-form[data-uuid='" + $(this).data('uuid') + "']").show();
        });
    });

    $($list.find('.report-abuse')).each(function () {
        $(this).click(function () {
            openModal($(this).attr('href'));

            return false;
        });
    });
}

function addCommentToList($wrapper, $list, comment) {
    $list.find('.comment-section').prepend(comment);
    totalCommentsDisplayed++;
    totalComments++;

    $wrapper.find('.comment-body').each(function() {
        $(this).val('');
    });

    initCommentButtons($list);
    initReplies($wrapper, $list, null);
}

function addReplyToList($wrapper, $list, form, parentUuid, comment) {
    var replySection = $list.find(".replies[data-parent-uuid='" + parentUuid + "']");

    replySection.prepend(comment);

    form.hide();

    var uuid = form.data('parent-uuid');

    totalReplies[uuid]++;
    totalRepliesDisplayed[uuid]++;

    $wrapper.find('.comment-body').each(function() {
        $(this).val('');
    });

    initCommentButtons($list);
    initReplies($wrapper, $list, null);
}

function updateComments($wrapper, $list, $loadMoreComments, $url) {
    $url = ($url.indexOf("?") > 0) ? $url += '&' : $url += '?';

    $url = $url + 'total='+totalComments+'&offset='+totalCommentsDisplayed+'&limit='+$loadMoreComments.data('load');

    $.ajax({
        type: 'GET',
        url: $url,
        dataType: 'json',
        success: function(data) {
            $.each(data.comments, function (index, comment) {
                $list.find('.comment-section').append(comment);
                totalCommentsDisplayed++;
            });

            initCommentButtons($list);
            initReplies($wrapper, $list, null);
            initReplyTotals($list, null);

            if (data.total <= totalComments) {
                $loadMoreComments.hide();
            }
        }
    });
}

function updateReplies($wrapper, $list, $loadMoreReplies, $url) {
    var uuid = $loadMoreReplies.parent().find('.replies').data('parent-uuid');

    $url = ($url.indexOf("?") > 0) ? $url += '&' : $url += '?';

    $url = $url + 'total='+totalReplies[uuid]+'&offset='+totalRepliesDisplayed[uuid]+'&limit='+$loadMoreReplies.data('load');

    initReplyTotals($list, uuid);

    $.ajax({
        type: 'GET',
        url: $url,
        dataType: 'json',
        success: function(data) {
            $.each(data.comments, function (index, comment) {
                $list.find(".replies[data-parent-uuid='" + data.parentUuid + "']").append(comment);
                totalRepliesDisplayed[uuid]++;
            });

            initCommentButtons($list);
            initReplies($wrapper, $list, null);
            initReplyTotals($list, null);

            if (data.total <= totalRepliesDisplayed[uuid]) {
                $loadMoreReplies.hide();
            }
        }
    });
}

$('body')
    .on('click', '.complexity-tabs a', function(e) {
        if (validateServiceManager({checkForEmptyComplexities: false, changeTab: false, complexityTabSelector: '.complexity-tab--active'})) {
            showComplexityTab($(this).attr('href'), false);
        }

        e.preventDefault();
    })
    .on('click', '.btn--show-complexity-tab', function(e) {
        if (validateServiceManager({checkForEmptyComplexities: false, changeTab: false, complexityTabSelector: '.complexity-tab--active'})) {
            showComplexityTab($(this).attr('href'), true);
        }

        e.preventDefault();
    });

function showComplexityTab(href, scrollTo)
{
    var $target = $(href);

    if ($target.length > 0) {
        $('.complexity-tabs__active').removeClass('complexity-tabs__active');
        $('.complexity-tabs a[href="'+href+'"]').closest('li').addClass('complexity-tabs__active');

        $('.complexity-tab--active').removeClass('complexity-tab--active').addClass('complexity-tab--inactive');
        $target.removeClass('complexity-tab--inactive').addClass('complexity-tab--active');

        if (scrollTo) {
            $('html, body').animate({scrollTop: 0});
        }
    }
}

if (! $('html').hasClass('lt-ie9')) {
    $(window).on('scroll.donutChart', function() {
        $('.donut-chart:not(.initialised)').each(function() {
            var $donut = $(this);

            if (scrolledIntoView($donut)) {
                var $canvas = $donut.addClass('initialised').find('canvas'),
                    value = parseInt($canvas.attr('data-value')),
                    data = [
                        {
                            value: value,
                            color: $canvas.data('color-1')
                        },
                        {
                            value: 100 - value,
                            color: $canvas.data('color-2')
                        }
                    ],
                    options = {
                        showTooltips: false,
                        segmentShowStroke: false,
                        animationEasing: 'linear',
                        animationSteps : 40,
                        percentageInnerCutout : 0
                    };
                new Chart($canvas.get(0).getContext('2d')).Doughnut(data, options);
            }
        });
    }).trigger('scroll.donutChart');
}

function isScrolledIntoView(elem)
{
    var $elem = $(elem);
    var $window = $(window);

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();

    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$('.dotdotdot').dotdotdot();

function equalise()
{
    var abs = false;

    if (navigator && navigator.userAgent && navigator.userAgent.indexOf('MSIE 10') !== -1) {
        abs = true;
    }

    $('.js-equalise').each(function() {
        var $this = $(this);
        var selectors = $this.data('selector').split(',');
        var minWidth = parseInt($this.data('width'));
        var maxWidth = parseInt($this.data('max-width'));
        var group = $this.data('group');
        var $items;
        var windowW = $(window).width();

        if (isNaN(minWidth)) {
            minWidth = 0;
        }

        if (isNaN(maxWidth)) {
            maxWidth = 10000000;
        }

        for (var i in selectors) {
            $items = $this.find(selectors[i]).css('min-height','1px');

            if (windowW >= minWidth && windowW <= maxWidth) {
                if (typeof group != 'undefined') {
                    var iterations = Math.ceil($items.length / parseInt(group));
                    var start = 0;
                    var end = group;

                    for (var i = 1; i <= iterations; i++) {
                        if (start <= 0) {
                            $items.filter(':lt(' + end + ')').equalize(abs);
                        } else {
                            $items.filter(':gt(' + (start - 1) + '):lt(' + end + ')').equalize(abs);
                        }

                        start += group;
                    }
                } else {
                    $items.equalize(abs);
                }
            }
        }

        $items = $this.find('.js-equalise__item').css('min-height','1px');

        if (windowW >= minWidth && windowW <= maxWidth) {
            $items.equalize(abs);
        }
    });

    $('.js-equalise-list').each(function() {
        var $list = $(this);
        var $items = $list.find('li').css('min-height','1px');
        var minWidth = parseInt($list.data('width'));
        var group = $list.data('group');

        if (isNaN(minWidth)) {
            minWidth = 0;
        }

        if ($(window).width() >= minWidth) {
            if (typeof group != 'undefined') {
                var iterations = Math.ceil($items.length / parseInt(group));
                var start = 0;
                var end = group;

                for (var i = 1; i <= iterations; i++) {
                    if (start <= 0) {
                        $items.filter(':lt(' + end + ')').equalize(abs);
                    } else {
                        $items.filter(':gt(' + (start - 1) + '):lt(' + end + ')').equalize(abs);
                    }

                    start += group;
                }
            } else {
                $items.equalize(abs);
            }
        }
    });
}

$(window).resize(equalise).load(equalise);

if (window.addEventListener) {
    window.addEventListener('orientationchange', equalise);
}

;(function ($) {
    // Fade out an element after the specified number of milliseconds
    $('[data-fade-out-after]').each(function () {
        var $element = $(this);
        var milliseconds = parseInt($element.attr('data-fade-out-after'));

        if (milliseconds !== 0) {
            setTimeout(function () {
                $element.fadeOut();
            }, milliseconds);
        }
    });
})(jQuery);

var faqSearchFormProcessing = false;
var timer = null;

$(document).on('keyup keypress', '.faqs-search-form form', function(e) {
    var $form = $(this);
    var $searchTerm = $form.find('input[name="search_term"]').val();
    var $url = $form.attr('action');
    var $targetClass = '.faq-search-results';

    if (e.keyCode == 13) {
        e.preventDefault();
        e.stopImmediatePropagation();
    }

    clearTimeout(timer);
    timer = setTimeout(function() {
        if ($searchTerm.length == 1) {
            return false;
        }

        faqSearchFormProcessing = true;
        $.ajax({
            type: 'GET',
            url: $url,
            data: $form.serialize(),
            success: function (data) {
                $data = $(data);

                $($targetClass).empty();
                $($targetClass).html($data.find($targetClass).html());

                setupAccordions();
            }
        }).complete(function() {
            faqSearchFormProcessing = false;
        });
    }, 200);
});

// Disable submit button on page load
$('.js-filter-submit').prop('disabled', 'disabled');

// Enable submit button if an input value changes
$('.title-filter').find(':input').on('change', function () {
    $('.js-filter-submit').prop('disabled', false);
});

// Change button text when submitting
$('.title-filter__filter').on('submit', function (e) {
    $('.js-filter-submit').prop('disabled', 'disabled').text('Loading');
});

$('body').on('submit', '.form-submit-loading', function() {
    var $form = $(this);

    if ($form.valid()) {
        addBtnLoading($form.find('[type="submit"]'));
    }
});

function addBtnLoading($btn) {
    if (! $btn.attr('disabled')) {
        $btn.attr('disabled', true);
        $btn.after('<i class="btn-loading fa fa-spinner fa-pulse"></i>');
    }
}

function removeBtnLoading() {
    var $loading = $('.btn-loading ');

    $loading.prev().attr('disabled', false);
    $loading.remove();
}

function formsSetup() {
    $('form').each(function () {
        $(this).validate();
    });

    // http://www.decorplanit.com/plugin/
    $('.js-format-price').each(function() {
        var $this = $(this);

        $this.autoNumeric('init', {
            lZero: 'deny',
            mDec: (typeof $this.data('decimal') != 'undefined') ? $this.data('decimal') : 0,
            wEmpty: 'empty'
        });
    });

    $('.js-format-percentage').each(function() {
        var $this = $(this);

        var maxValue = $(this).attr('max') || 100;

        $this.autoNumeric('init', {
            wEmpty: 'empty',
            lZero: 'deny',
            aSign: '',
            pSign: 's',
            vMin: 0,
            vMax: parseInt(maxValue),
            mDec: (typeof $this.data('decimal') != 'undefined') ? $this.data('decimal') : 2,
            aPad: false
        });
    });

    $('.js-select-slider').each(function () {
        var $select = $(this);
        var sliderLength = $select.find('option').length;
        var sliderLabelWidth = 100 / (sliderLength - 1);
        var $slider = $('<div class="slider"><div class="slider__labels"><ul></ul></div></div>').insertAfter($select).slider({
            min: 1,
            max: sliderLength,
            range: 'min',
            value: $select[0].selectedIndex + 1,
            slide: function (event, ui) {
                var index = ui.value - 1;

                $select[0].selectedIndex = index;
                $select.trigger('change');

                $slider.find('.slider_labels__selected').removeClass('slider_labels__selected');
                $slider.find('.slider__labels li:eq('+index+')').addClass('slider_labels__selected');
            }
        });

        $slider.find('.slider__labels').css('left', '-' + (sliderLabelWidth / 2) + '%');

        $select.find('option').each(function (index) {
            var liClass = '';
            if ($select[0].selectedIndex == index) {
                liClass = ' class="slider_labels__selected"';
            }

            var liStyle = 'width: ' + sliderLabelWidth + '%;';
            if (index === (sliderLength - 1)) {
                liStyle += 'position: absolute; right: -' + sliderLabelWidth + '%;';
            }

            $slider.find('.slider__labels ul').append('<li'+liClass + ' style="' + liStyle + '">' + $(this).text() + '</li>');
        });
    });

    // This must be called after the slider
    // Limit plugin to selects in .wrapper and .modal only
    setupSelectBoxIt('.wrapper, .modal');

    if ($('body').hasClass('device-mobile') || $('body').hasClass('device-tablet')) {
        $('.datepicker:not(.datepicker--force)').each(function() {
            var $date = $(this);
            var v = $date.val();

            $date.attr('type', 'date');
            $date.attr('placeholder', '');

            if (v != '') {
                var date = v.split('/');

                $date.val(date[2]+'-'+date[1]+'-'+date[0]);
            }
        });

        addDatepicker('.datepicker--force');

        $('.datepicker--force')
            .on('focus', function() {
                $('html').addClass('fixfixed');
                $(this).trigger('blur');
            });
    } else {
        addDatepicker('.datepicker');
    }

    maskedInput();

    $('.js-restrict-chars').trigger('keyup');
    $('.js-min-chars').trigger('keyup');
    $('select.js-select-hide').trigger('change');
    $('select.js-select-show').trigger('change');
    $('.js-val-to-text').trigger('keyup');
    $('.js-val-to-val').trigger('keyup');
    $('.js-checkbox-to-text').trigger('change');

    $('html.lt-ie10 label.tiny, label.tiny--show').tinyLabels();

    catchUnsavedForm();

    $('.js-bordered-checkboxes-restrict-selection input[type="checkbox"]').on('change', function() {
        var $parent = $(this).closest('.js-bordered-checkboxes-restrict-selection');
        var $checkboxes = $parent.find('input[type="checkbox"]');

        $checkboxes.removeAttr('disabled').closest('li').css('opacity', 1);

        if ($checkboxes.filter(':checked').length >= parseInt($parent.data('max'))) {
            $checkboxes.filter(':not(:checked)').attr('disabled', 'disabled').closest('li').css('opacity', 0.5);
        }
    }).trigger('change');
}

function setupSelectBoxIt(selector)
{
    $(selector).find('select').each(function () {
        var $select = $(this);

        var $parent = $select.parent();

        if ($parent.find('.selectboxit-container').length > 0) {
            return;
        }

        var options = {
            dynamicPositioning: false,
            showFirstOption: false
        };

        if ($select.data('default-text')) {
            options['defaultText'] = $select.data('default-text');

            // If setting default text, probably want to show first option too
            options['showFirstOption'] = true;
        }

        if ($select.hasClass('select--show-first-option') || $select.data('show-first-option')) {
            options['showFirstOption'] = true;
        }

        if ($select.hasClass('select--hide-current')) {
            options['hideCurrent'] = true;
        }

        var selectBoxIt = $select.selectBoxIt(options);

        if ($select.hasClass('select--1-option')) {
            selectBoxIt.data('selectBox-selectBoxIt').disable();
        }

        if ($select.hasClass('select--use-longest-option')) {
            var longest = '';

            $select.find('option').each(function() {
                var text = $(this).text();

                if (text.length > longest.length) {
                    longest = text;
                }
            });

            $select.parent().find('.selectboxit-text').attr('data-longest-option', longest);
        }
    });
}

$('body')
    .on('click', '.js-clear-field', function () {
        $(this).closest('.form-row').find('input, textarea, select')
            .val('')
            .trigger('change');
    })
    .on('keyup', '.js-restrict-chars', function () {
        var $input = $(this);
        var $counter = $('#'+$input.attr('id') + '-restrict-chars').find('span');
        var v = $input.val();
        var count = v.length;
        var maxlength = parseInt($counter.data('max'));
        var newCount = maxlength - count;

        if (newCount < 0) {
            newCount = 0;

            $input.val(v.substr(0, maxlength));
        }

        $counter.text(newCount);
    })
    .on('keyup', '.js-min-chars', function () {
        var $input = $(this);
        var $counter = $('#'+$input.attr('id') + '-min-chars').find('span');
        var v = $input.val();
        var count = v.length;
        var minlength = parseInt($counter.data('min'));
        var newCount = minlength - count;

        if (newCount < 0) {
            newCount = 0;
        }

        if (newCount == minlength) {
            $counter.text(newCount);
        } else {
            $counter.text(newCount+' remaining');
        }
    })
    .on('keyup', '.js-remove-line-breaks', function () {
        var $input = $(this);
        var v = $input.val();

        $input.val(v.replace(/(\r\n|\n|\r)/gm," ").replace(/\s\s+/g, ' '));
    })
    .on('change', 'select.js-select-hide', function () {
        var $select = $(this);
        var prefix = $select.data('prefix');

        $('.js-select-hide-' + prefix).show().removeClass('js-select-hide--hidden');
        $('.' + prefix + '-' + $select.val()).hide().addClass('js-select-hide--hidden');
    })
    .on('change', 'select.js-select-show', function () {
        var $select = $(this);
        var prefix = $select.data('prefix');

        $('.js-select-show-' + prefix).hide();
        $('.' + prefix + '-' + $select.val()).show();

        if (typeof window[$select.data('callback')] === 'function') {
            window[$select.data('callback')]($select);
        }
    })
    .on('keyup change', '.js-val-to-text', function () {
        var $field = $(this);
        var $elem = $($field.data('elem'));
        var v = $field.val();

        if ($field.hasClass('js-format-price')) {
            v = v.replace('£ ', '£');
            v = v.replace('.00', '');

            if (v === '0' || v === '£0') {
                v = 'FREE';
            } else {
                v = '£'+v;
            }
        } else if ($field.hasClass('js-format-percentage')) {
            v += '%';
        }

        $elem.text(v);
    })
    .on('keyup change', '.js-val-to-val', function () {
        var $field = $(this);
        $($field.data('elem')).val($field.val());
    })
    .on('change', '.js-checkbox-to-text', function() {
        var $checkbox = $(this);
        var $i = $($checkbox.data('elem')).find('i');

        if ($checkbox.prop('checked')) {
            $i.attr('class', $i.data('tick'));
        } else {
            $i.attr('class', $i.data('cross'));
        }
    })
    .on('click', '.js-form-reveal', function (e) {
        $(this).hide().closest('.form-row').find('.form-row__update__reveal').show();

        e.preventDefault();
    })
    .on('change', '.js-submit-on-change', function () {
        $(this).closest('form').submit();
    });

formsSetup();

function showHideContactSlots()
{
    if ($('input[name="contact_method"]:checked').val() == 'email') {
        $('.form-row--contact-slots').hide();
    } else {
        $('.form-row--contact-slots').show();
    }
}

var tinyLabelInputBlurTimer = false;
$('html.lt-ie10 #frm-search-postcode').on('blur keyup', function() {
    if (tinyLabelInputBlurTimer !== false) {
        clearTimeout(tinyLabelInputBlurTimer);
    }

    tinyLabelInputBlurTimer = setTimeout(function() {
        $('label.tiny').next().trigger('tinyLabelInputBlur');
    }, 100);
});

function addDatepicker(selector)
{
    $(selector).removeAttr('max', '').removeAttr('min', '').each(function () {
        var $datepicker = $(this);
        var minDate = (typeof $datepicker.data('min-date') !== 'undefined') ? $datepicker.data('min-date') : null;
        var maxDate = (typeof $datepicker.data('max-date') !== 'undefined') ? $datepicker.data('max-date') : null;
        var dateFormat = (typeof $datepicker.data('date-format') !== 'undefined') ? $datepicker.data('date-format') : 'dd/mm/yy';

        $datepicker.on('focusin', function (e) {
            $(this).prop('readonly', true);
        });

        $datepicker.on('focusout', function (e) {
            $(this).prop('readonly', false);
        });

        $datepicker.datepicker({
            changeMonth: true,
            changeYear: true,
            firstDay: 1,
            dateFormat: dateFormat,
            minDate: minDate,
            maxDate: maxDate,
            yearRange: '-100:c+10',
            beforeShowDay: function (date) {
                var $datepicker = $(this);

                if ($datepicker.hasClass('datepicker--mondays')) {
                    if (date.getDay() === 1) {
                        return [true, '', ''];
                    }

                    return [false, '', ''];
                } else if ($datepicker.hasClass('datepicker--sundays')) {
                    if (date.getDay() === 0) {
                        return [true, '', ''];
                    }

                    return [false, '', ''];
                }

                return [true, '', ''];
            },
            onClose: function () {
                $('html').removeClass('fixfixed');
            },
            onSelect: function () {
                $(this).trigger('change').trigger('blur');
            }
        });

        $datepicker
            .on('change', function() {
                var $datepicker = $(this);
                var selectedDate = $datepicker.val();

                if (selectedDate != '' && typeof $datepicker.data('to') !== 'undefined') {
                    if (selectedDate == '') {
                        selectedDate = 0;
                    }

                    $($datepicker.data('to')).val('').datepicker('option', 'minDate', selectedDate);
                }
            });
    });
}

/**
 * Checks if an element has been scrolled into view
 *
 * @param $elem jQuery element to check
 * @param fully boolean whether $elem is fully in view
 * @returns {boolean}
 */
function scrolledIntoView($elem, fully)
{
    if ($elem.length === 0) {
        return false;
    }

    var $window = $(window);

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();

    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();

    if (typeof fully === 'boolean' && fully === false) {
        return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
    }

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

var loadFile = function(event, input) {
    var output = $(input.data('output-id'));
    output.attr('src', URL.createObjectURL(event.target.files[0]));
};

/**
 * Returns the number of weeks between 2 dates
 *
 * @param date1 date object
 * @param date2 date object
 * @returns {number}
 */
function weeksBetweenDates(date1, date2) {
    // The number of milliseconds in one week
    var ONE_WEEK = 1000 * 60 * 60 * 24 * 7;

    // Convert both dates to milliseconds
    var date1_ms = date1.getTime();
    var date2_ms = date2.getTime();

    // Calculate the difference in milliseconds
    var difference_ms = Math.abs(date1_ms - date2_ms);

    // Convert back to weeks and return hole weeks
    return Math.ceil(difference_ms / ONE_WEEK);
}

$(window).bind('pageshow', function(e) {
    if (e.originalEvent.persisted) {
        window.location.reload()
    }
});

/*
 * TODO - remove this
 */
function gaSendEvent(category, action, label)
{
    // this needs to be removed
    // search codebase for this function
    // search codebase for forms with data-ga-event-label
}

// Miscellaneous jQuery extensions.
;(function ($) {

    // Toggle visibility based on a boolean.
    // Usage: $(selector).showIf(true);
    $.fn.showIf = function (boolean) {
        return this.each(function () {
            if (boolean) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    };

    // Toggle class based on a boolean
    // Usage: $(selector).addClassIf('class-name', true);
    $.fn.addClassIf = function (className, boolean) {
        return this.each(function () {
            if (boolean) {
                $(this).addClass(className);
            } else {
                $(this).removeClass(className);
            }
        });
    };

})(jQuery);

function addLoading(colour) {
    removeLoading();

    $('body').append('<div class="loading loading--'+colour+'"><div class="loading__inner"><i class="fa fa-spinner fa-pulse"></i></div></div>');
}

function addAbsoluteLoading($elem) {
    removeLoading();

    $elem.append('<div class="loading loading--absolute loading--bg-white loading--blue"><div class="loading__inner"><i class="fa fa-spinner fa-pulse"></i></div></div>');
}

function removeLoading() {
    $('.loading').remove();
}

/*
 https://igorescobar.github.io/jQuery-Mask-Plugin/
 */

function maskedInput()
{
    $('.masked-input-time').mask('AB:CD', {
        'translation': {
            A: {pattern: /[0-2]/},
            B: {pattern: /[0-9]/},
            C: {pattern: /[0-5]/},
            D: {pattern: /[0-9]/}
        }
    });

    $('.masked-input-numbers').mask('#A', {
        reverse: true,
        'translation': {
            A: {pattern: /[0-9]/}
        }
    });

    if ($('body').hasClass('device-desktop')) {
        $('.datepicker').mask('00/00/0000');
    }
}

maskedInput();

if ($('.team-bio').length > 0) {
    $('.team__member a').click(function(e) {
        if ($('.team-bio--open').is(':animated')) {
            e.preventDefault();

            return false;
        }

        var $this = $(this);
        var $bio = $this.closest('.team__core').next();
        var isOpen = $this.closest('.team__member').hasClass('team__member--open');

        if (isOpen) {
            $('.team__member--open').removeClass('team__member--open');
            $('.team-bio--open').removeClass('team-bio--open').slideUp();
        } else {
            $('.team__member--open').removeClass('team__member--open');
            $this.closest('.team__member').addClass('team__member--open');

            if (!$bio.hasClass('team-bio--open')) {
                $('.team-bio--open').removeClass('team-bio--open').slideUp();
            }

            $bio.find('.core').html($this.find('.team__member__bio').html());
            $bio.addClass('team-bio--open').slideDown();
        }

        e.preventDefault();
    });
}

$('body')
    .on('click', '.mega-tooltip', function (e) {
        var $megaTooltip = $(this);
        var $bubble = $($megaTooltip.attr('href'));
        var isOpen = $megaTooltip.hasClass('mega-tooltip--open');

        $('.mega-tooltip--open').removeClass('mega-tooltip--open');
        $('.mega-tooltip__bubble').hide();

        if ($bubble.length > 0 && isOpen === false) {
            $megaTooltip.addClass('mega-tooltip--open');

            $bubble.css({
                'top': $megaTooltip.offset().top + $megaTooltip.outerHeight(),
                'left': $megaTooltip.offset().left
            }).show();

            if ($('body').hasClass('device-desktop')) {
                $bubble.find('input[type!="hidden"]:first').focus();
            }
        }

        e.preventDefault();
    });

$('.mega-tooltip__close').click(function (e) {
    $('.mega-tooltip--open').removeClass('mega-tooltip--open');
    var $bubble = $('.mega-tooltip__bubble').hide();

    $bubble.find('form').get(0).reset();
    $bubble.find('.tmp').remove();

    e.preventDefault();
});

$(document).on('click', function (e) {
    if ($('.mega-tooltip--open').length > 0) {
        var $target = $(e.target);
        if (! $target.hasClass('mega-tooltip') && ! $target.hasClass('mega-tooltip__bubble') && $target.closest('.mega-tooltip__bubble').length === 0) {
            $('.mega-tooltip__close').trigger('click');
        }
    }
});

$('.js-open-modal-video').click(function(e) {
    e.preventDefault();

    $('body').append(
        '<div class="modal-video">' +
            '<div class="core">' +
                '<div class="modal-video__center">' +
                    '<div class="modal-video__video"></div>' +
                    '<a href="javascript:;" class="modal-video__close js-close-modal-video">' +
                        '<i class="icon-cross2"></i>' +
                    '</a>' +
                '</div>' +
            '</div>' +
        '</div>'
    );

    var $modalVideo = $('.modal-video');

    $modalVideo.find('.modal-video__video').append('<iframe frameborder="0" src="'+$(this).attr('href')+'"></iframe>');
    $modalVideo.fadeIn();

    var player = new Vimeo.Player($modalVideo.find('iframe').get(0));

    player.on('ended', function() {
        closeModalVideo();
    });
});

$('body').on('click', '.js-close-modal-video', function(e) {
    e.preventDefault();

    closeModalVideo();
});

function closeModalVideo()
{
    var $modalVideo = $('.modal-video');

    $modalVideo.find('.modal-video__video').html('');
    $modalVideo.fadeOut(function() {
        $modalVideo.remove();
    });
}

$(function() {
   $('body')
       .on('click', '.js-open-modal-window', function (e) {
           e.preventDefault();

           var $modal = $($(this).attr('href'))
               .addClass('modal-window--open')
               .fadeIn();

           $(document).trigger('modal-window-opened', [$modal]);
       })
       .on('click', '.js-close-modal-window', function (e) {
           e.preventDefault();

           var $modal = $('.modal-window--open')
               .removeClass('modal-window--open')
               .fadeOut();

           $(document).trigger('modal-window-closed', [$modal]);
       });
});

var modalLoading = false;
var windowScrollTop = 0;
var modalZIndex = 30000;

$('body')
    .on('click', '.open-modal', function(e) {
        var $this = $(this);
        var options = {};

        if ($this.data('replace-modal')) {
            options.removeModal ='#'+$this.closest('.modal').attr('id');
        }

        if ($this.data('modal-class')) {
            options.modalClass = $this.data('modal-class');
        }

        if ($this.data('opened-callback')) {
            options.openedCallback = $this.data('opened-callback');
        }

        if (typeof $this.data('html-open-class') != 'undefined') {
            options.addHTMLOpenClass = $this.data('html-open-class');
        }

        if (typeof window[$this.data('validation')] === 'function') {
            if (window[$this.data('validation')]() === false) {
                e.preventDefault();

                return false;
            }
        }

        if ($this.data('form')) {
            var $form = $($this.data('form'));

            options.type = $form.attr('method');
            options.data = $form.serialize();
        }

        if ($this.hasClass('open-modal-loading')) {
            addBtnLoading($this);
        }

        openModal($this.attr('href'), options);

        e.preventDefault();
    }).on('click', '.close-modal, .modal-background', function(e) {
        var modalId = $(this).closest('.modal').attr('id');

        if (typeof modalId != 'undefined') {
            closeModal('#'+modalId);
        } else {
            closeModal();
        }

        e.preventDefault();
    });

function openModal(url, options) {
    options = $.extend({
        type: 'GET',
        url: url,
        dataType: 'html',
        success: function(data) {
            $(modalId).show();

            if(typeof dataLayer != "undefined") {
                dataLayer.push({
                    'event':'VirtualPageview',
                    'virtualPageURL': url.replace(/\?resultSetUuid.+/, '')
                });    
            } else {
                window.ga && window.ga("send", "pageview", url.replace(/\?resultSetUuid.+/, ''));
            }

            if (options.addHTMLOpenClass) {
                $('html').addClass('html--modal-open');
            }

            $(modalId).find('.modal__content').html($(data).find('.modal__content').html()).fadeIn();
        },
        addHTMLOpenClass: true
    }, options);

    if ($('.modal:visible').length == 0) {
        windowScrollTop = $(window).scrollTop();
    }

    if (modalLoading === false) {
        modalLoading = true;

        var modalId;

        if (url.substr(0, 1) === '#') {
            modalId = url;

            if ($(modalId).hasClass('modal')) {
                $(modalId).show().addClass('modal--in-page');

                if (options.addHTMLOpenClass) {
                    $('html').addClass('html--modal-open');
                }

                $(modalId).find('.modal__content').fadeIn();
            } else {
                modalId = createModal();

                $(modalId).show();

                if (options.addHTMLOpenClass) {
                    $('html').addClass('html--modal-open');
                }

                $(modalId).find('.modal__content').html($(url).html()).fadeIn();
            }

            options.modalId = modalId;

            modalLoaded(options);
        } else {
            modalId = createModal();

            options.modalId = modalId;

            $.ajax(options).complete(function() {
                modalLoaded(options);
            });
        }

        return modalId;
    }

    $('#comparison-results').append('<div class="modal-background"></div>');
}

function modalLoaded(options) {
    if (typeof options.removeModal != 'undefined') {
        closeModal(options.removeModal);
    }

    if (typeof options.modalClass != 'undefined') {
        $(options.modalId).addClass(options.modalClass);
    }

    //var scrollbarWidth = ($('.modal').width() - $('.modal__content').width()) - 1;

    //$('.modal__fixed').css('right', scrollbarWidth);

    modalLoading = false;

    $('.dotdotdot').dotdotdot();
    formsSetup();
    picturefill();
    handleAjaxForms();
    removeBtnLoading();

    if (typeof proceedButtonText !== 'undefined') {
        $('.partner-profile__comparison-details__proceed .btn--proceed').text(proceedButtonText);
    }

    $(options.modalId).addClass('modal--open');

    if (typeof options.openedCallback != 'undefined' && typeof window[options.openedCallback] === 'function') {
        window[options.openedCallback](options);
    }

    $('#comparison-results').append('<div class="modal-background"></div>');
}

function closeModal(selector, destroy) {
    if (typeof selector == 'undefined') {
        selector = '.modal';
    }

    if ($('.modal:visible').length < 2) {
        $('html').removeClass('html--modal-open');

        $(window).scrollTop(windowScrollTop);
    }

    if (typeof destroy == 'undefined') {
        $(selector).delay(50).fadeOut(function() {
            $(selector).filter(':not(.modal--in-page)').remove();
        });
    } else {
        $(selector).filter(':not(.modal--in-page)').remove();
    }

    $('.modal-background').remove();
}

function createModal() {
    var modalId = 'modal-'+new Date().getTime();
    modalZIndex++;

    $('body').prepend('<div id="'+modalId+'" class="modal" style="z-index: '+modalZIndex+';"><div class="modal__content"></div></div>');

    history.pushState(null, null, "#" + modalId);

    return '#'+modalId;
}

$(window).on('popstate', function () {
    $(".close-modal").trigger("click");
});

var isDesktop = $('body').hasClass('device-desktop');

if (isDesktop) {
    $('.js-nav-personal').click(function(e) {
        e.preventDefault();

        if ($('.footer--open-nav-personal').length > 0) {
            return closeDropNav();
        }

        $('.footer')
            .removeClass('footer--open-nav-business')
            .addClass('footer--open-nav-personal');

        $('.drop-nav__categories-wrapper--personal .drop-nav__products').each(function() {
            $(this).find('li').equalize();
        });

        $(this).find('i').removeClass('icon-arrow4-down').addClass('icon-arrow4-up');
    });

    $('.js-nav-business').click(function(e) {
        e.preventDefault();

        if ($('.footer--open-nav-business').length > 0) {
            return closeDropNav();
        }

        $('.footer')
            .removeClass('footer--open-nav-personal')
            .addClass('footer--open-nav-business');

        $('.drop-nav__categories-wrapper--business .drop-nav__products').each(function() {
            $(this).find('li').equalize();
        });

        $(this).find('i').removeClass('icon-arrow4-down').addClass('icon-arrow4-up');
    });

    $('.drop-nav__categories > li > a').click(function(e) {
        var $this = $(this);
        var $wrapper = $this.closest('.drop-nav__categories-wrapper');

        $wrapper.find('.drop-nav__categories li.selected').removeClass('selected');
        $this.closest('li').addClass('selected').find('ul > li:first').addClass('selected');

        e.preventDefault();
    });

    $('.drop-nav__sub-categories > li > a').click(function(e) {
        var $this = $(this);
        var $wrapper = $this.closest('.drop-nav__categories-wrapper');

        $wrapper.find('.drop-nav__sub-categories li.selected').removeClass('selected');
        $this.closest('li').addClass('selected');

        e.preventDefault();
    });

    $(document).click(function(e) {
        var $target = $(e.target);
        if (!$target.hasClass('drop-nav__core') && $target.closest('.drop-nav__core').length === 0 && $target.closest('.header__nav').length === 0) {
            closeDropNav();
        }
    });
}

function closeDropNav()
{
    $('.footer')
        .removeClass('footer--open-nav-personal')
        .removeClass('footer--open-nav-business');

    $('.js-nav-personal, .js-nav-business').find('i').removeClass('icon-arrow4-up').addClass('icon-arrow4-down');
}

var isMobile = $('body').hasClass('device-mobile') || $('body').hasClass('device-tablet');

if (isMobile) {
    $('.header__burger').click(function(e) {
        var $html = $('html');

        if ($html.hasClass('html--mobile-nav-open')) {
            $html.removeClass('html--mobile-nav-open');

            $('.header')
                .removeClass('header--open-nav-account');

            $('.footer')
                .removeClass('footer--open-nav-business')
                .removeClass('footer--open-nav-personal');

            setTimeout(function() {
                $('.header__nav').removeClass('header__nav--overflow-hidden').hide();

                $('.drop-nav, .account-dropdown').attr('style', '');
                $('.drop-nav [style]').attr('style', '');

                $('.drop-nav .selected').removeClass('selected');
                $('.account-dropdown .selected').removeClass('selected');
            }, 300);
        } else {
            $('.header__nav').show(0, function() {
                $html.addClass('html--mobile-nav-open');
            });
        }

        e.preventDefault();
        e.stopPropagation();
    });

    $('.js-open-account-nav').click(function(e) {
        $('.header__burger').trigger('click');
        $('.js-nav-account').trigger('click');

        e.preventDefault();
        e.stopPropagation();
    });

    $('.header__nav, .drop-nav, .account-dropdown').click(function(e) {
        var $target = $(e.target);

        if ($target.hasClass('header__nav') || $target.hasClass('drop-nav') || $target.hasClass('account-dropdown')) {
            $('.html--mobile-nav-open .header__burger').trigger('click');
        }
    });

    $('.js-nav-account').click(function(e) {
        $('.header__nav').scrollTop(0);
        $('.account-dropdown').scrollTop(0);

        $('.account-dropdown').show(0, function() {
            $('.header')
                .addClass('header--open-nav-account');

            $('.footer')
                .removeClass('footer--open-nav-personal')
                .removeClass('footer--open-nav-business');

            $('.header__nav').addClass('header__nav--overflow-hidden');
        });

        e.preventDefault();
        e.stopPropagation();
    });

    $('.js-nav-sub-account').click(function(e) {
        var $this = $(this);

        $('.account-dropdown').scrollTop(0);
        $('.account-dropdown .selected').removeClass('selected');

        $this.closest('li').find('> ul').show(0, showUL);

        e.preventDefault();
        e.stopPropagation();
    });

    $('.js-nav-sub-sub-account').click(function(e) {
        var $this = $(this);

        $('.account-dropdown').scrollTop(0);

        $this.closest('li').find('> ul').show(0, showUL);

        e.preventDefault();
        e.stopPropagation();
    });

    $('.js-nav-personal').click(function(e) {
        $('.header__nav').scrollTop(0);

        $('.drop-nav .selected').removeClass('selected');

        $('.drop-nav').show(0, function() {
            $('.header')
                .removeClass('header--open-nav-account');

            $('.footer')
                .removeClass('footer--open-nav-business')
                .addClass('footer--open-nav-personal');

            $('.header__nav').addClass('header__nav--overflow-hidden');
        });

        e.preventDefault();
        e.stopPropagation();
    });

    $('.js-nav-business').click(function(e) {
        $('.header__nav').scrollTop(0);

        $('.drop-nav .selected').removeClass('selected');

        $('.drop-nav').show(0, function() {
            $('.header')
                .removeClass('header--open-nav-account');

            $('.footer')
                .removeClass('footer--open-nav-personal')
                .addClass('footer--open-nav-business');

            $('.header__nav').addClass('header__nav--overflow-hidden');
        });

        e.preventDefault();
        e.stopPropagation();
    });

    $('.drop-nav__categories > li > a').click(function(e) {
        var $this = $(this);

        if (! $this.hasClass('link')) {
            $('.drop-nav').removeClass('drop-nav--overflow-hidden').scrollTop(0);
            $('.drop-nav__categories .selected').removeClass('selected');

            $this.closest('li').find('> ul').show(0, showUL);

            e.preventDefault();
            e.stopPropagation();
        }
    });

    $('.drop-nav__sub-categories > li > a').click(function(e) {
        var $this = $(this);

        $('.drop-nav').removeClass('drop-nav--overflow-hidden').scrollTop(0);
        $('.drop-nav__sub-categories .selected').removeClass('selected');

        $this.closest('li').find('> ul').show(0, showUL);

        e.preventDefault();
        e.stopPropagation();
    });

    $('.drop-nav__previous--categories, .drop-nav__previous--account').click(function(e) {
        $('.header--open-nav-account').removeClass('header--open-nav-account');
        $('.footer--open-nav-personal').removeClass('footer--open-nav-personal');
        $('.footer--open-nav-business').removeClass('footer--open-nav-business');
        $('.header__nav--overflow-hidden').removeClass('header__nav--overflow-hidden')

        setTimeout(function() {
            $('.drop-nav, .account-dropdown').attr('style', '');
        }, 300);

        e.preventDefault();
        e.stopPropagation();
    });

    $('.drop-nav__previous--sub-categories, .drop-nav__previous--products, .drop-nav__previous--sub-account').click(function(e) {
        var $li = $(this).closest('.selected');

        $('.drop-nav').removeClass('drop-nav--overflow-hidden').scrollTop(0);
        $li.removeClass('selected');

        setTimeout(function() {
            $li.find('ul').attr('style', '');
        }, 300);

        checkDropNavOverflow($li.parent());

        e.preventDefault();
        e.stopPropagation();
    });

    function showUL()
    {
        var $ul = $(this);

        $ul.closest('li').addClass('selected');

        checkDropNavOverflow($ul);
    }

    function checkDropNavOverflow($ul)
    {
        var h = ($ul.find('> li').length * $ul.find('> li:last').height()) + 200;

        if (h < $(window).height()) {
            $('.drop-nav').addClass('drop-nav--overflow-hidden');
        } else {
            $('.drop-nav').removeClass('drop-nav--overflow-hidden');
        }
    }

    if (window.addEventListener) {
        window.addEventListener('orientationchange', function () {
            $('.selected > ul').each(function () {
                checkDropNavOverflow($(this));
            });
        });
    }
}

$('body')
    .on('click', '.js-dismiss-notification', function (e) {
        e.preventDefault();

        var $notification = $(this).addClass('btn--with-icon2').append(' <i class="fa fa-spinner fa-pulse"></i>').closest('li');
        var $form = $notification.find('form');
        var url = $form.prop('action');
        var _token = $('meta[name="csrf-token"]').attr('content');

        var $emptyNotifications = '<div style="padding: 0 0 50px;">' +
            '<div class="tooltip-info tooltip-info--relative" style="margin: 0;">' +
            '<h4>Notifications</h4>' +
            '<p>There are no new notifications</p>' +
            '<span class="tooltip-info__triangle"></span>' +
            '</div>' +
            '</div>';

        $.ajax({
            method: 'PUT',
            url: url
        }).complete(function (data) {
            // TODO: Re-factor dismissing notification logic

            // We should NOT be requesting full HTML pages, pages that have multiple
            // API calls which means more bandwidth is used, and repsonse times are
            // increased.
            var $data = $(data.responseText);
            var $subnavNotifications = $('.notifications--subnav');

            $('.account-dropdown').html($data.find('.account-dropdown').html());

            if ($notification.closest('.notifications--subnav').length > 0) {
                $subnavNotifications.find('ul').html($data.find('#unacknowledged ul').html());
            } else {
                $('#unacknowledged').html($data.find('#unacknowledged').html());
                $('#acknowledged').html($data.find('#acknowledged').html());
            }

            equalise();

            $notification.fadeOut(function() {
                $notification.remove();
                
                if ($subnavNotifications.find('li').length === 0) {
                    $subnavNotifications.remove();
                } else {
                    $subnavNotifications.find('li:gt(1)').remove();
                }
            });
        });
    })
    .on('click', '.js-dismiss-notification-redirect', function() {
        var $this = $(this);
        var $notification = $this.closest('.js-notification');

        if ($notification.length > 0) {
            var dismissUrl = $notification.data('dismiss-url');

            $this.attr('href', dismissUrl+''+$this.attr('href'));
        }
    });

// Inject notification count into sub-nav via AJAX
$('.account-dropdown__notification-count').each(function () {
    var $count = $(this);
    var $link = $count.closest('a');
    var url = $link.attr('href') + '/count';

    $count.load(url, function (count) {
        return parseInt(count);
    });
});

$('.js-opening-times').change(function() {
    var $this = $(this);
    var $inputs = $this.closest('.office-profile__opening-hours').find('.office-profile__opening-hours__times input[type="text"]');

    if ($this.is(':checked')) {
        $inputs.attr('readonly', true).val('').attr('placeholder', 'Closed').each(function() {
            var $input = $(this);
            $input.removeClass('required').removeClass('error');
            $input.closest('.form-row').removeClass('form-row--error');
        });
    } else {
        $inputs.attr('readonly', false).each(function() {
            var $input = $(this);
            $input.attr('placeholder', $input.data('placeholder')).addClass('required');
        });
    }

    if ($('.office-profile__opening-hours__closed input:checked').length == 7) {
        $('.js-trading-hours-error-message').show().closest('.form-row').addClass('form-row--error');
        $('input[name="is_trading_hours_valid"]').val('');
    } else {
        $('.js-trading-hours-error-message').hide().closest('.form-row').removeClass('form-row--error');
        $('input[name="is_trading_hours_valid"]').val('1');
    }
}).trigger('change');

$(window).on('scroll.opportunityChart', function() {
    var $chart = $('.opportunity-chart');

    if (scrolledIntoView($chart.find('.opportunity-chart__key'))) {
        $chart.addClass('opportunity-chart--animate');
    } else if (scrolledIntoView($chart.find('.opportunity-chart__scoring'))) {
        $chart.addClass('opportunity-chart--animate');
    }
}).trigger('scroll.opportunityChart');

$('body').on('click', '.partner-profile__tabs a', function(e) {
    var $link = $(this);
    var $target = $($link.attr('href'));

    if ($target.length > 0) {
        $('.partner-profile__tabs__active').removeClass('partner-profile__tabs__active');
        $('.partner-profile__tabs a[href="'+$link.attr('href')+'"]').closest('li').addClass('partner-profile__tabs__active');

        $('.partner-profile__tab-content--active').removeClass('partner-profile__tab-content--active');
        $target.addClass('partner-profile__tab-content--active');
    }

    e.preventDefault();
});

$('.js-add-branch').click(function(e) {
    var $addBranch = $('#partner-add-branch').show();

    $('#partner-register-interest').hide();

    $addBranch.find('input[type!="checkbox"][type!="radio"]').val('').trigger('change');
    $addBranch.find('input[type="checkbox"], input[type="radio"]').attr('checked', false).prop('checked', false).trigger('change');

    $addBranch.find('select').each(function() {
        $(this).val('').data('selectBox-selectBoxIt').refresh();
    });

    e.preventDefault();
});

$('.js-add-another-branch').click(function(e) {
    var $addBranch = $('#partner-add-branch');

    $('.stages__steps__step--selected').removeClass('stages__steps__step--selected');

    $addBranch.find('input[type!="checkbox"][type!="radio"]').val('').trigger('change');
    $addBranch.find('input[type="checkbox"], input[type="radio"]').attr('checked', false).prop('checked', false).trigger('change');

    $addBranch.find('select').each(function() {
        $(this).val('').data('selectBox-selectBoxIt').refresh();
    });

    $addBranch.find('.stages__steps').show().find('li').removeClass('selected').removeClass('completed').first().addClass('selected');
    $addBranch.find('.ajax-form__form').show();
    $addBranch.find('.ajax-form__thank-you').hide();
    $addBranch.find('.stages__steps__step:first').addClass('stages__steps__step--selected');

    $('html, body').animate({scrollTop: $addBranch.offset().top});

    e.preventDefault();
});

$('.js-add-branch-select-contact').change(function() {
    var $fields = $('.js-add-branch-contact-field');
    var $select = $(this);
    var v = $select.val();
    var $selectedOption = $select.find('option[value="'+v+'"]');

    if (v === '0' || v === '' || v === null) {
        $fields.filter('input').attr('readonly', false).val('').trigger('change');

        $fields.filter('select').each(function() {
            $(this).val('').data('selectBox-selectBoxIt').enable();
        });
    } else {
        $fields.filter('input').attr('readonly', true).val('').trigger('change');

        $fields.filter('select').each(function() {
            $(this).val('').data('selectBox-selectBoxIt').disable();
        });

        $fields.filter('[name="salutation"]').val($selectedOption.data('salutation'));
        $fields.filter('[name="first_name"]').val($selectedOption.data('first'));
        $fields.filter('[name="last_name"]').val($selectedOption.data('last'));
        $fields.filter('[name="email"]').val($selectedOption.data('email'));
        $fields.filter('[name="phone"]').val($selectedOption.data('phone'));
    }

    $fields.removeClass('error');

    $fields.filter('select').each(function() {
        $(this).data('selectBox-selectBoxIt').refresh();
    });
});

$('.js-partners-account-delete-contact').click(function(e) {
    openModal($(this).data('modal-selector'));
    e.preventDefault();
});

$('.manage-office-form select[name="change_office"]').change(function(e) {
    $('.manage-office-form').submit();
});

$('.category-product-info__category').click(function (e) {
    if ($('.category-product-info__products').is(':animated')) {
        e.preventDefault();

        return false;
    }

    var $title = $(this);

    $title.parent().toggleClass('category-product-info__row--open');
    $title.next().slideToggle();
});

var partnersProductManagerToggleEnable = true;
var featuredChargesJqXHR = false;

$('body')
    .on('change', '.js-partners-product-manager-disable-product', function() {
        var $checkbox = $(this);

        if (! $checkbox.prop('checked')) {
            openModal($checkbox.data('modal-id'));
        } else {
            if (partnersProductManagerToggleEnable) {
                $.ajax({type: 'GET', url: $checkbox.data('url-toggle-enable')});
            } else {
                partnersProductManagerToggleEnable = true;
            }
        }

        if ($checkbox.prop('checked')) {
            $('.complexity-tabs__active i').removeClass('text-grey').addClass('text-green');
        } else {
            $('.complexity-tabs__active i').removeClass('text-green').addClass('text-grey');
        }
    })
    .on('change', '.featured-listing-start-date', function (e) {
        var $startDate = $(this);
        var $endDate = $('.featured-listing-end-date');

        var endDate = $startDate.datepicker('getDate');
        endDate.setDate(endDate.getDate() + 6);

        $endDate.datepicker('setDate', endDate);
    })
    .on('click', '.js-form-add-featured-listing', function(e) {
        var $btn = $(this);
        var $container = $btn.closest('.manage-listing');
        var $pricingModel = $container.find('.featured-listing-pricing-model');
        var $valueInputs = $container.find('.manage-listing__form .form-row:visible input[type="text"]').removeClass('error');
        var $productFlagCheckboxes = $container.find('.form-row--product-flags:visible input[type="checkbox"]').removeClass('error');
        var $startDate = $container.find('.featured-listing-start-date').removeClass('error');
        var $endDate = $container.find('.featured-listing-end-date').removeClass('error');
        var valid = true;
        var values = [];
        var productFlags = [];
        var disbursement = '';
        var i;

        $container.find('.manage-listing__text__error').remove();

        i = 0;
        $valueInputs.each(function() {
            var $input = $(this);

            if ($input.closest('.form-row:visible').length > 0 && $.trim($input.val().replace('£', '').replace('%', '')) == '') {
                $input.addClass('error');
                valid = false;
            } else {
                values[i] = {
                    name: $input.data('name'),
                    value: $input.val()
                };

                i++;
            }
        });

        i = 0;
        $productFlagCheckboxes.each(function() {
            var $input = $(this);

            if ($input.prop('checked')) {
                productFlags[i] = $input.data('name');

                i++;
            }
        });

        if (productFlags.length === 0 && $productFlagCheckboxes.length > 0) {
            $productFlagCheckboxes.addClass('error');
            valid = false;
        }

        $container.find('.form-row--disbursement-providers:visible input[type="radio"]').each(function() {
            var $input = $(this);

            if ($input.prop('checked')) {
                disbursement = $input.data('name');
            }
        });

        var startDateParts = $startDate.val().split('/');
        var startDate = new Date();
        startDate.setDate(startDateParts[0]);
        startDate.setMonth(parseInt(startDateParts[1])-1);
        startDate.setFullYear(startDateParts[2]);

        var endDateParts = $endDate.val().split('/');
        var endDate = new Date();
        endDate.setDate(parseInt(endDateParts[0]));
        endDate.setMonth(parseInt(endDateParts[1])-1);
        endDate.setFullYear(endDateParts[2]);

        if (isNaN(weeksBetweenDates(startDate, endDate))) {
            $startDate.addClass('error');
            $endDate.addClass('error');
            valid = false;
        }

        if (valid) {
            $.ajax({
                type: 'post',
                url: $btn.data('submit-featured-listing-url'),
                data: {
                    pricingModelUuid: $pricingModel.val(),
                    values: values,
                    productFlags: productFlags,
                    disbursement: disbursement,
                    startDate: $startDate.val(),
                    endDate: $endDate.val()
                },
                beforeSend: function() {
                    addAbsoluteLoading($container);
                },
                success: function(data) {
                    if (data.errors != '') {
                        $container.find('.manage-listing__text:first').prepend('<p class="manage-listing__text__error text-red">'+data.errors+'</p>');
                    } else {
                        $container.find('.manage-listing__featured-history').show();

                        $pricingModel.val($pricingModel.find('option:first').attr('value')).trigger('change');
                        $valueInputs.val('').trigger('blur');
                        $startDate.val('').trigger('change');
                        $endDate.val('').trigger('change');

                        $container.find('.manage-listing__meta-form__total__value b').html('<strong>&pound;0</strong>');
                    }

                    if (data.featuredListings != '') {
                        var $tbodyNew = $(data.featuredListings).find('tbody');
                        var $tbody = $('tbody[class="'+$tbodyNew.attr('class')+'"]');

                        $tbody.find('tr.is-draft').remove();
                        $tbody.prepend($tbodyNew.html());
                    }
                }
            }).complete(function() {
                removeLoading();
            });
        }

        e.preventDefault();
    })
    .on('click', '.js-enable-product', function(e) {
        partnersProductManagerToggleEnable = false;

        $($(this).data('checkbox-id')).prop('checked', 'checked').trigger('change');

        e.preventDefault();
    })
    .on('click', '.js-disable-product', function(e) {
        $.ajax({type: 'GET', url: $($(this).data('checkbox-id')).data('url-toggle-enable')});

        e.preventDefault();
    })
    .on('click', '.js-form-delete-featured-listing', function(e) {
        var $btn = $(this);
        var $container = $btn.closest('.manage-listing__featured-history');

        $.ajax({
            type: 'get',
            url: $btn.attr('href'),
            beforeSend: function() {
                addAbsoluteLoading($container);
            },
            success: function(data) {
                if (data.errors == '') {
                    var $tr = $btn.closest('tr');
                    var $featuredHistory = $tr.closest('.manage-listing').find('.manage-listing__featured-history');

                    $tr.remove();

                    if ($featuredHistory.find('tbody tr').length === 0) {
                        $featuredHistory.hide();
                    }
                }
            }
        }).complete(function() {
            removeLoading();
        });

        e.preventDefault();
    })
    .on('change', '.featured-listing-start-date', updateFeaturedCosts)
    .on('change', '.featured-listing-end-date', updateFeaturedCosts);

function updateFeaturedCosts()
{
    var $complexityTab = $('.complexity-tab--active');
    var $totalCost = $complexityTab.find('.manage-listing__meta-form__total__value');
    var startAt = $complexityTab.find('.featured-listing-start-date').val();
    var endAt = $complexityTab.find('.featured-listing-end-date').val();
    var $btn = $('.manage-listing__meta-form__add').find('.btn');
    var $underSaturationError = $('.alert--under-saturation');
    var $overlappingError = $('.alert--overlapping');

    if (startAt != '' && endAt != '') {
        $totalCost.find('b').hide();
        $totalCost.find('i').css('display','inline-block');

        if (featuredChargesJqXHR !== false) {
            featuredChargesJqXHR.abort();
        }

        featuredChargesJqXHR = $.ajax({
            beforeSend: function () {
                $underSaturationError.hide();
                $overlappingError.hide();
            },
            type: 'GET',
            url: $complexityTab.find('.form-row--feature-to').data('url-charges'),
            data: {
                startAt: startAt,
                endAt: endAt
            },
            success: function(data) {
                if (typeof data.extra !== 'undefined' && typeof data.extra.costPerPeriod !== 'undefined') {
                    $totalCost.find('b').html(data.extra.costHTML);
                    $complexityTab.find('.featured-listing-cost-per-period').val(data.extra.costPerPeriod);

                    $btn.prop('disabled', true).addClass('disabled');

                    if (data.extra.isUnderSaturation === false) {
                        $underSaturationError.show();
                    } else if (data.extra.isOverlappingForOffice === true || data.extra.isOverlappingForOrganisation === true) {
                        $overlappingError.show();
                    } else {
                        $btn.prop('disabled', false).removeClass('disabled');
                    }
                }
            }
        }).complete(function() {
            $totalCost.find('i').hide();
            $totalCost.find('b').show();
            featuredChargesJqXHR = false;
        });
    } else {
        $totalCost.find('strong span').text(0);
        $complexityTab.find('.featured-listing-cost-per-period').val(0);
    }
}

function serviceTooltip($tooltip)
{
    var colour = '';
    var icon = '';

    if ($($tooltip.parent().attr('href')).find('.js-partners-product-manager-disable-product').prop('checked')) {
        colour = 'green';
    } else {
        colour = 'grey';
    }

    if ($tooltip.hasClass('icon-tick2')) {
        icon = 'tick2';
    } else {
        icon = 'cross3';
    }

    return $tooltip.data('text-'+colour+'-'+icon);
}

function validateServiceManager(options)
{
    options = $.extend({
        checkForEmptyComplexities: true,
        changeTab: true,
        complexityTabSelector: '.complexity-tab'
    }, options);

    if ($('.error').length > 0) {
        return false;
    }

    $('.manage-listing__error').hide();
    $('.is-empty-input').removeClass('is-empty-input');
    $('.error').removeClass('error');

    var isValid = validateServiceManagerStandardListings(options);

    if (isValid) {
        isValid = validateServiceManagerFeaturedListings(options);
    }

    return isValid;
}

function validateServiceManagerStandardListings(options)
{
    var isValid = true;
    var goToFirstComplexity = true;
    var goToComplexity = '';
    var validComplexities = 0;

    $(options.complexityTabSelector).each(function() {
        var $tab = $(this);
        var $pricingModel = $tab.find('.form-row--standard-pricing-model select');
        var $inputs = $('.'+$pricingModel.data('prefix')+'-'+$pricingModel.val()).find('.js-validate-service-manager');
        var validInputs = 0;
        var complexityId = '#'+$tab.attr('id');

        $inputs.each(function() {
            var $input = $(this);

            if ($.trim($input.val()) != '') {
                $input.removeClass('is-empty-input');

                validInputs++;
            } else {
                $input.addClass('is-empty-input');
            }
        });

        if ($inputs.length == validInputs) {
            validComplexities++;
        } else if (validInputs > 0) {
            isValid = false;

            if ($tab.hasClass('complexity-tab--active')) {
                goToFirstComplexity = false;
            }

            if (goToComplexity == '' || $tab.hasClass('complexity-tab--active')) {
                goToComplexity = complexityId;
            }
        }
    });

    if (options.checkForEmptyComplexities && validComplexities == 0) {
        isValid = false;

        if (goToFirstComplexity || goToComplexity == '') {
            goToComplexity = '#'+$('.complexity-tab:first').attr('id');
        }
    }

    if (isValid === false && goToComplexity !== '') {
        var $manageListing = $(goToComplexity).find('.manage-listing--standard');

        $manageListing.find('.manage-listing__error').show();
        $manageListing.find('.is-empty-input').addClass('error');

        if (options.changeTab) {
            showComplexityTab(goToComplexity, false);
        }

        $('html, body').animate({scrollTop: $manageListing.offset().top - 160});

        return false;
    }

    return true;
}

function validateServiceManagerFeaturedListings(options)
{
    var isValid = true;
    var goToComplexity = '';

    $(options.complexityTabSelector).each(function() {
        var $tab = $(this);
        var $pricingModel = $tab.find('.form-row--featured-pricing-model select');
        var $inputs = $('.'+$pricingModel.data('prefix')+'-'+$pricingModel.val()).find('.js-validate-service-manager');
        var validInputs = 0;
        var complexityId = '#'+$tab.attr('id');

        $inputs.each(function() {
            var $input = $(this);

            if ($.trim($input.val()) != '') {
                $input.removeClass('is-empty-input');

                validInputs++;
            } else {
                $input.addClass('is-empty-input');
            }
        });

        var $manageListing = $(complexityId).find('.manage-listing--featured');
        var $startDate = $manageListing.find('.featured-listing-start-date');
        var $endDate = $manageListing.find('.featured-listing-end-date');

        if (validInputs > 0) {
            var validDates = true;

            if ($.trim($startDate.val()) == '') {
                validDates = false;
                $startDate.addClass('is-empty-input');
            } else {
                $startDate.removeClass('is-empty-input');
            }

            if ($.trim($endDate.val()) == '') {
                validDates = false;
                $endDate.addClass('is-empty-input');
            } else {
                $endDate.removeClass('is-empty-input');
            }

            if ($inputs.length != validInputs || validDates === false) {
                isValid = false;

                if (goToComplexity == '' || $tab.hasClass('complexity-tab--active')) {
                    goToComplexity = complexityId;
                }
            }
        } else {
            $startDate.val('');
            $endDate.val('');
        }
    });

    if (isValid === false && goToComplexity !== '') {
        var $manageListing = $(goToComplexity).find('.manage-listing--featured');

        $manageListing.find('.manage-listing__error').show();
        $manageListing.find('.is-empty-input').addClass('error');

        if (options.changeTab) {
            showComplexityTab(goToComplexity, false);
        }

        $('html, body').animate({scrollTop: $manageListing.offset().top - 160});

        return false;
    }

    return true;
}

function serviceManagerComplexityLoaded($elem)
{
    var $form = $elem.closest('form');

    if ($form.hasClass('js-catch-unsaved-form')) {
        $form.data('original', $form.serialize());

        isUnsavedForm = false;
    }
}

var searchWatchersJqXHR = false;

$('body')
    .on('submit', '.js-frm-search-watchers', function (e) {
        searchWatchers($(this));

        e.preventDefault();
    })
    .on('keyup', '.js-input-search-watchers', function () {
        // Debounce this so AJAX request isn’t performed for EVERY key press
        $(this).closest('form').submit();
    })
    .on('click', '.js-add-watcher', function (e) {
        var $this = $(this);
        var complexityUuid = $('.complexity-tab--active').data('uuid');

        $('.complexity-tab--active .manage-contacts__set-watchers__list li:last').before(
            '<li>' +
                '<a href="javascript:;" class="manage-contacts__set-watchers__remove js-remove-watcher">'+
                    '<input type="hidden" name="listing['+complexityUuid+'][added_watchers][]" value="'+$this.data('uuid')+'" />'+
                    $this.text().replace(' +', '')+
                    ' <i class="icon-cross3"></i>' +
                '</a>' +
            '</li>'
        );

        $this.closest('li').remove();

        $('.mega-tooltip__close').trigger('click');

        e.preventDefault();
    })
    .on('click', '.js-remove-watcher', function (e) {
        var $input = $(this).removeClass('js-remove-watcher').closest('li').fadeOut().find('input');
        var name = $input.attr('name')
            .replace('[watchers]', '[deleted_watchers]')
            .replace('[added_watchers]', '[deleted_watchers]');

        $input.attr('name', name);

        e.preventDefault();
    })
    .on('click', '.manage-contacts__set-watchers__cta-add', function (e) {
        var $form = $('.js-frm-search-watchers');
        $form.find('[name="ignore"]').val($($(this).data('owner')).val());
    });

function searchWatchers($form)
{
    if (searchWatchersJqXHR !== false) {
        searchWatchersJqXHR.abort();
    }

    if ($form.valid()) {
        searchWatchersJqXHR = $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: 'html',
            success: function (data) {
                $('.mega-tooltip__suggestion-list').remove();

                $form.after(data);

                var $list = $('.mega-tooltip__suggestion-list');

                $('.complexity-tab--active .js-remove-watcher').each(function () {
                    $list.find('[data-uuid="'+$(this).find('input').val()+'"]').closest('li').remove();
                });

                if ($list.find('li').length === 0) {
                    $list.remove();
                    data = '';
                }

                if ($.trim(data) === '') {
                    $form.after('<p class="mega-tooltip__suggestion-list">No contacts found.<br />Please try again.</p>');
                }

                $('.mega-tooltip__suggestion-list').addClass('tmp');
            }
        }).complete(function () {
            searchWatchersJqXHR = false;
        });
    }
}

var ajaxQualifyingQuestionsProcessing = false;
var ajaxSaveAndExitProcessing = false;

showHideContinueQuestions();

$('.header-actions')
    .on('click', '.save-and-exit-btn', function (e) {
        saveAndExit();

        e.preventDefault();
    });

$('.qualifying-questions-wrapper')
    .on('keyup change', '.js-continue-questions-check-input', function () {
        var $this = $(this);

        if ($this.val() != '' && $this.val() != '£') {
            $('.js-question-show-continue').val(1);
        } else {
            $('.js-question-show-continue').val(0);
        }

        if (typeof $this.data('related') != 'undefined') {
            var $related = $($this.data('related'));

            if ($related.attr('type') == 'checkbox') {
                if ($related.prop('checked')) {
                    $('.js-question-show-continue').val(1);
                }
            } else if ($related.val() != '') {
                $('.js-question-show-continue').val(1);
            }
        }

        //postcode check
        if ( $('.js-continue-questions-check-input').parent().hasClass('form-row--postcode') ) {

            $('.js-question-show-continue').val(1);
            if ($('.msg-error--postcode').length > 0) $('.msg-error--postcode').remove();
            $('.form-row--postcode input').removeClass('msg-error--red-outline-thick');

            var postcodeCheck = new RegExp('^\\s*[a-zA-Z]{1,2}[0-9]{1,2}[a-zA-Z]?\\s*[0-9][a-zA-Z]{2}\\s*$');

            if ( postcodeCheck.test($this.val()) ) {
                $('.js-continue-questions').removeClass('btn-disabled');
            } else {
                $('.js-continue-questions').addClass('btn-disabled');
            }
        }

        showHideContinueQuestions();
    })
    .on('click', '.js-continue-questions.btn--arrow.btn-disabled', function (e) {
        if ( $(this).parent().hasClass('form-row--postcode') ) {
            e.preventDefault();
            postcodeErrorMessage();
        }
    })
    .on('click', '.js-continue-questions.btn-disabled', function (e) {
        if ( $(this).parent().prev().find('.form-row').hasClass('form-row--postcode')) {
            e.preventDefault();
            postcodeErrorMessage();
        }
    })
    .on('click', '.selection__option input[checked="checked"]', function () {
        $(this).trigger('change');
    })
    .on('change', '.js-continue-questions-check-input-checkbox', function () {
        var $this = $(this);

        if ($this.prop('checked')) {
            $('.js-question-show-continue').val(1);
        } else {
            $('.js-question-show-continue').val(0);
        }

        if (typeof $this.data('related') != 'undefined') {
            var $related = $($this.data('related'));

            if ($related.attr('type') == 'checkbox') {
                if ($related.prop('checked')) {
                    $('.js-question-show-continue').val(1);
                }
            } else if ($related.val() != '') {
                $('.js-question-show-continue').val(1);
            }

            if ($this.val() == 'unknown') {
                if ($this.prop('checked')) {
                    $related.val('').attr('readonly', true);
                } else {
                    $related.val('').attr('readonly', false);
                }
            }
        }

        showHideContinueQuestions();

        if ($this.attr('type') == 'radio' || $this.parent().hasClass('checkbox--button2')) {
            $this.closest('form').submit();
        }
    });

$('.qualifying-questions-wrapper--ajax')
    .on('submit', 'form', function (e) {
        var $form = $(this);

        $('html, body').animate({scrollTop: 0});

        if ($form.valid() && $('.js-question-show-continue').val() == '1' && ajaxQualifyingQuestionsProcessing === false) {
            ajaxQualifyingQuestionsProcessing = true;

            // ensure if the postcode field is present in the form, that it is trimmed of unwanted space
            if ( $('.form-row--postcode input').size() ) {
                $('.form-row--postcode input').val($('.form-row--postcode input').val().trim());
            }

            var jqXHR = $.ajax({
                type: $form.attr('method'),
                url: $form.attr('action'),
                data: $form.serialize(),
                beforeSend: function () {
                    addLoading('white');
                    $('.js-continue-questions').hide();
                }
            });

            jqXHR.done(function (data) {
                loadQuestion(data);
            });

            jqXHR.fail(function (jqXHR, textStatus, errorThrown) {
                $('.js-continue-questions').show();
            });

            jqXHR.always(function (data, textStatus) {
                ajaxQualifyingQuestionsProcessing = false;
                removeLoading();
            });
        }
        e.preventDefault();

    })
    .on('click', '.js-qualifying-questions-back', function (e) {
        $('html, body').animate({scrollTop: 0});

        if (ajaxQualifyingQuestionsProcessing === false) {
            ajaxQualifyingQuestionsProcessing = true;
            $.ajax({
                type: 'GET',
                url: $(this).attr('href'),
                dataType: 'html',
                beforeSend: function () {
                    addLoading('white');
                },
                success: function (data) {
                    loadQuestion(data);
                },
                error: function () {
                    ajaxQualifyingQuestionsProcessing = false;
                    removeLoading();
                }
            }).complete(function () {
                ajaxQualifyingQuestionsProcessing = false;
                removeLoading();
            });
        }

        e.preventDefault();
    });

function loadQuestion(data) {
    if (typeof data.redirect !== 'undefined') {
        addLoading('white');

        setTimeout(function () {
            addLoading('white');

            $('.progress__percentage').css('width', '100%').text('100%');
        }, 50);

        window.location = data.redirect;
    } else {
        var $data = $(data);
        var headerActions = $data.find('.header-actions').html();
        var html = $data.find('.qualifying-questions-wrapper').html();
        var newProgress = $data.find('.progress__percentage').text();
        var currentProgress = $('.progress__percentage').text();

        $('.header-actions').html(headerActions);
        $('.qualifying-questions-wrapper').html(html);
        $('.progress__percentage').css('width', currentProgress).text(currentProgress);

        setTimeout(function () {
            $('.progress__percentage').css('width', newProgress).text(newProgress);
        }, 50);

        showHideContinueQuestions();
        formsSetup();

        $('.device-desktop .qualifying-questions-wrapper').find('.focus').focus();

        History.pushState({
            type: 'qualifyingQuestions'
        }, $('.questions__question__name').text(), $('.questions').data('question-url'));
        if ($('.questions__question').length > 0) {
            if (typeof dataLayer !== "undefined") {
                dataLayer.push({'event':'VirtualPageview',
                                'virtualPageURL': $('.questions').data('question-canonical-uri')
                               });
            } else if (window.ga) {
                window.ga('send', 'pageview', $('.questions').data('question-canonical-uri'));
            } else {
                console.warn('Google Analytics is not installed.');
                console.log('send', 'pageview', $('.questions').data('question-canonical-uri'));
            }
        }
    }
}

function saveAndExit() {
    var $btn = $('.save-and-exit-btn');

    $.ajax({
        type: 'GET',
        url: $btn.attr('href'),
        beforeSend: function () {
            $btn.prop('disabled', true);
            $btn.find('i.fa-spinner').remove();
            $btn.addClass('btn--with-icon2').append('<i class="fa fa-spinner fa-pulse"></i>');
        },
        error: function (jqXHR, textStatus, errorThrown) {
            $btn.removeClass('btn--with-icon2').find('i.fa-spinner').remove();

            if (errorThrown == 'Unauthorized') {
                openModal(jqXHR.responseJSON.auth_url + '?callbackFunction=saveAndExit');
            }
        },
        success: function (data) {
            $btn.find('i.fa-spinner').remove();
            $btn.addClass('btn--with-icon2').append('<i class="icon-tick2 text-green"></i>');

            if (data.redirect_url) {
                window.location.href = data.redirect_url;
            }
        }
    }).complete(function () {
        $btn.prop('disabled', false);
    });
}

function showHideContinueQuestions() {
    if ($('.js-question-show-continue').val() == '1') {
        $('.js-continue-questions').show();
    } else {
        $('.js-continue-questions').hide();
    }
}

function postcodeErrorMessage() {
    if ($('.msg-error--postcode').length > 0) $('.msg-error--postcode').remove();
    $('.form-row--postcode').append('<div class="msg-error msg-error--red-text msg-error--white-box msg-error--red-outline-thick msg-error--postcode">Please enter a valid postcode</div>');
    $('.form-row--postcode input').addClass('msg-error--red-outline-thick');
}

History.Adapter.bind(window, 'statechange', function () {
    var state = History.getState();

    if (typeof state.data.type != 'undefined' && state.data.type == 'qualifyingQuestions') {
        if (ajaxQualifyingQuestionsProcessing === false) {
            ajaxQualifyingQuestionsProcessing = true;
            $.ajax({
                type: 'GET',
                url: window.location,
                dataType: 'html',
                beforeSend: function () {
                    addLoading('white');
                },
                success: function (data) {
                    loadQuestion(data);
                }
            }).complete(function () {
                ajaxQualifyingQuestionsProcessing = false;
                removeLoading();
            });
        }
    }
});

(function ($) {
    $('body').on('click', '.js-scroll-to', function(e) {
        var $link = $(this);
        var url = window.location.protocol+'//'+window.location.host+window.location.pathname;
        var href = $link.attr('href').replace(url, '');
        var isModal = $('html').hasClass('html--modal-open');
        var selector = isModal ? '.modal' : 'html, body';

        if (href.substring(0, 1) == '#' || href.indexOf('#') !== 0) {
            if (href == '#' || href == 'javascript:;') {
                $(selector).animate({scrollTop: 0});
            } else {
                var $target;

                if (href.substring(0, 1) == '#') {
                    $target = $(href);
                } else {
                    var parts = href.split('#');

                    $target = $('#'+parts[1]);
                }

                if ($target.length > 0) {
                    var t = $target.offset().top;

                    if (isModal) {
                        t = t + $(selector).scrollTop();
                    } else {
                        t = t - $('.header').height();
                    }

                    $(selector).animate({scrollTop: t});
                }
            }

            e.preventDefault();
        }
    });

    $(window).load(scrollToSection).on('hashchange', scrollToSection);

    function scrollToSection() {
        var section = $_GET('section');
        var hash = window.location.hash+'';

        if (hash !== '') {
            $(window).scrollTop(0);
            section = hash.substr(1);
        }

        if (section) {
            var $target = $('#'+section);

            if ($target.length > 0) {
                $(window).scrollTop($target.offset().top - $('.header').height());

                if ($target.hasClass('accordion')) {
                    $target.find('.accordion__title a').trigger('click');
                }
            }
        }
    }
})(jQuery);

var searchFormProcessing = false;
var timer = null;

$(document).mouseup(function(e) {
    if ($('.show-search-suggestions__form').has(e.target).length === 0) {
        $(".search-suggestions").addClass('search-suggestions--hidden');
    }
});

$('.device-desktop #frm-full-width-search-personal').focus();
$('.device-desktop #frm-full-width-search-business').focus();

initSearchForms();

function initSearchForms() {
    $('.show-search-suggestions').each(function() {
        var $wrapper = $(this);
        var $form = $wrapper.find('.show-search-suggestions__form');
        var $target = $wrapper.find('.suggestions-container');

        $form.on('keyup focus', 'input[name="search"]', function(e) {
            if ($form.find('input[name="search"]').val() != '') {
                if (e.keyCode != 13 && e.keyCode != 38 && e.keyCode != 40) {
                    doSuggestions($target, $form);
                }
            } else {
                $form.closest('.show-search-suggestions').find('.search-suggestions').addClass('search-suggestions--hidden');
            }

            e.preventDefault();
        });

        $form.on('keyup', 'input[name="search"]', function(e) {
            var $suggestions = $('.search-suggestions--simple');

            if ($suggestions.length > 0) {
                var $current = $suggestions.find('.search-suggestions__highlight');

                if (e.keyCode == 13) {
                    // enter
                    if ($current.length > 0) {
                        window.location = $current.attr('href');

                        e.preventDefault();
                    }
                } else if (e.keyCode == 38) {
                    // up arrow
                    if ($current.length > 0) {
                        $current.removeClass('search-suggestions__highlight');
                        $current.parent().prev().prev().find('a').addClass('search-suggestions__highlight');
                    } else {
                        $suggestions.find('p:last a').addClass('search-suggestions__highlight');
                    }
                } else if (e.keyCode == 40) {
                    // down arrow
                    if ($current.length > 0) {
                        $current.removeClass('search-suggestions__highlight');
                        $current.parent().next().next().find('a').addClass('search-suggestions__highlight');
                    } else {
                        $suggestions.find('p:first a').addClass('search-suggestions__highlight');
                    }
                }
            }
        });
    });
}

function doSuggestions($target, $form) {
    clearTimeout(timer);
    timer = setTimeout(function() {
        if ($form.find('input[name="search"]').val().length == 1) {
            return false;
        }

        searchFormProcessing = true;
        $.ajax({
            type: 'GET',
            url: $form.data('suggestions-url'),
            data: $form.serialize(),
            dataType: 'json',
            success: function(data) {
                $target.empty();
                var $thisForm = $form.find('input[name="search"]').closest('.show-search-suggestions');

                $thisForm.find('.search-suggestions').removeClass('search-suggestions--hidden');

                if ($thisForm.hasClass('homepage-search')) {
                    var $personal = $('.suggestions-container-personal').empty();
                    var $business = $('.suggestions-container-business').empty();

                    $personal.append('<h3>Personal legal services</h3>');

                    if (data.personal.elements.length === 0) {
                        $personal.append('<p>No personal legal services found</p>');
                    } else {
                        $.each(data.personal.elements, function(i, suggestion) {
                            appendSuggestion($personal, suggestion);
                        });
                    }

                    $business.append('<h3>Business legal services</h3>');

                    if (data.business.elements.length === 0) {
                        $business.append('<p>No business legal services found</p>');
                    } else {
                        $.each(data.business.elements, function(i, suggestion) {
                            appendSuggestion($business, suggestion);
                        });
                    }
                } else {
                    if (data.elements.length === 0) {
                        $target.html('No search suggestions');
                        $thisForm.find('.search-suggestions').addClass('search-suggestions--hidden');
                    } else {
                        $.each(data.elements, function(i, suggestion) {
                            appendSuggestion($target, suggestion);
                        });
                    }
                }
            }
        }).complete(function() {
            searchFormProcessing = false;
        });

    }, 200);
}

function appendSuggestion($element, $suggestion) {
    var $resultType = $suggestion.extra.type;
    var $resultTitle = $suggestion.title;

    if ($suggestion.extra.type == 'service') {
        $resultType = $suggestion.extra.category;
    }

    $element.append('<h4>'+$resultType+'</h4><p><a class="search-suggestion-item" id="suggestion-'+$resultTitle+'" href="'+$suggestion.url+'">'+$resultTitle+'</a></p>');
}

$('.share__share').on('click', function() {
    $(this).closest('.share').toggleClass('share--open');
});

$('a.share__email').click(function() {
    var $this = $(this);
    var subject = "";
    var body = "I thought you might find this interesting:\r\n\r\n"+$this.data('body')+"\r\n"+$this.data('url')+"";
    var mailto = "mailto:?";
    mailto += "subject="+encodeURIComponent(subject);
    mailto += "&body="+encodeURIComponent(body);
    window.location = mailto;
});

$('body')
    .on('click', '.js-show-hide', function(e) {
        var $link = $(this);
        var $elem = $($link.attr('href'));
        var dataScroll = $link.data('scroll');
        var scroll = (typeof dataScroll === 'undefined' || dataScroll === true);

        if ($elem.is(':animated')) {
            e.preventDefault();

            return false;
        }

        $('a[href="'+$link.attr('href')+'"]').toggleClass('js-show-hide--open');

        $elem.slideToggle();
        $elem.toggleClass('js-show-hide__open');

        if (scroll && $elem.hasClass('js-show-hide__open')) {
            $('html, body').animate({scrollTop: $elem.offset().top});
        }

        e.preventDefault();
    })
    .on('click', '.js-show-hide-close', function(e) {
        $(this).closest('.js-show-hide__open').toggleClass('js-show-hide__open').slideUp();

        e.preventDefault();
    });

$('.signaturepad-form').signaturePad({
    defaultAction: 'drawIt',
    drawOnly: true,
    validateFields: false,
    penColour: '#063041',
    bgColour: '#fff',
    lineTop: 115,
    lineMargin: 10,
    output: '.signaturepad-form__output',
    clear: '.signaturepad-form__clear'
});

$(window).on('scroll.slideshowInView', function() {
    $('.slideshow--scrolled-into-view:not(.initialised)').each(function() {
        var $slideshow = $(this);

        if (scrolledIntoView($slideshow, false)) {
            slideshowInitialise($slideshow);
        }
    });
}).trigger('scroll.slideshowInView');

function setupSlideshows()
{
    $('.slideshow:not(.slideshow--scrolled-into-view)').each(function() {
        slideshowInitialise($(this));
    });
}

function slideshowInitialise($slideshow)
{
    if ($slideshow.addClass('initialised').find('.slideshow__slides > li').length > 1) {
        var controls = $slideshow.find('.slideshow__controls');
        var pauseOnAction = $slideshow.data('pause-on-action') === true;
        var pauseOnHover = $slideshow.data('pause-on-hover') === true;

        if ($slideshow.find('.slideshow__slides__slide__caption').length > 0) {
            $slideshow.addClass('slideshow--in-page--has-caption');
        }

        $slideshow.addClass('has-flexslider').flexslider({
            selector: '.slideshow__slides > li',
            controlsContainer: controls,
            animation: 'fade',
            animationSpeed: 400,
            slideshow: true,
            controlNav: true,
            directionNav: false,
            pauseOnAction: pauseOnAction,
            pauseOnHover: pauseOnHover,
            before: function(slider) {
                $(document).trigger('slideshowBefore');
                slideshowRemoveVideo(slider);
            }
        });
    }
}

$('.slideshow__slides__slide__video-play').click(function(e) {
    var $a = $(this);
    var $slide = $a.closest('li');
    var $slideshow = $slide.closest('.slideshow');

    if ($slideshow.hasClass('has-flexslider')) {
        $slideshow.data('flexslider').flexslider('pause');
    }

    $slide
        .find('.slideshow__slides__slide__video')
        .addClass('slideshow__slides__slide__video--open')
        .html('<iframe src="'+$a.attr('href')+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');

    e.preventDefault();
});

function slideshowRemoveVideo(slider)
{
    $(slider)
        .find('.slideshow__slides__slide__video')
        .removeClass('slideshow__slides__slide__video--open')
        .html('');
}

setupSlideshows();

$('.js-sortable').disableSelection().sortable();
$('.js-sortable-horizontal').sortable('option', 'axis', 'x');
$('.js-sortable-vertical').sortable('option', 'axis', 'y');

$('.device-mobile .js-btn-stages-previous').click(function() {
    $('html, body').animate({scrollTop: $(this).closest('.stages').offset().top});
});

$('.device-mobile .js-btn-stages-next').click(function() {
    $('html, body').animate({scrollTop: $(this).closest('.stages').offset().top});
});

$('.js-btn-stages-previous').click(function() {
    showStep($(this).closest('.stages__steps__step'), 'prev');
});

$('.js-btn-stages-next').click(function() {
    showStep($(this).closest('.stages__steps__step'), 'next');
});

$('.stages__steps__step input').keypress(function(e) {
    if (e.keyCode == 13) {
        e.preventDefault();

        $(this).closest('.stages__steps__step').find('.js-btn-stages-next').trigger('click');
    }
});

function resetSteps($stages)
{
    var $stepsList = $stages.find('.stages__steps li');

    $stages.find('.stages__steps__step--selected').removeClass('stages__steps__step--selected');
    $stages.find('.stages__steps__step:first').addClass('stages__steps__step--selected');

    $stepsList.filter('li.completed').removeClass('completed');
    $stepsList.filter('li.selected').removeClass('selected');
    $stepsList.filter(':first').addClass('selected');
}

function showStep($currentStep, direction)
{
    if (direction == 'next') {
        var is_valid = false;
        var $form = $currentStep.closest('form');

        if ($form.length > 0) {
            $form.valid();

            is_valid = ($currentStep.find('input.error, textarea.error, select.error').length === 0);

            if (is_valid) {
                $('input.error, textarea.error, select.error').removeClass('error');
            } else {
                return false;
            }
        }
    }

    var $stepsList = $currentStep.closest('.stages').find('.stages__steps li');

    $currentStep.removeClass('stages__steps__step--selected');

    if (direction == 'prev') {
        $currentStep.prev().addClass('stages__steps__step--selected');
        $stepsList.filter('.selected:last').removeClass('selected').prev().removeClass('completed').addClass('selected');
    } else {
        $currentStep.next().addClass('stages__steps__step--selected');
        $stepsList.filter('.selected:last').removeClass('selected').addClass('completed').next().addClass('selected');
    }

    checkCompletedSteps();
}

function checkCompletedSteps()
{
    $('.stages__steps__step--selected').each(function() {
        var $stages = $(this).closest('.stages');
        if ($stages.find('.stages__steps__step--selected').hasClass('stages__steps__step--thank-you')) {
            $stages.find('.stages__steps').hide();
        } else {
            $stages.find('.stages__steps').show();
        }
    });
}

function completeSteps($stages)
{
    $stages.find('.stages__steps__step--selected').removeClass('stages__steps__step--selected');
    $stages.find('.stages__steps__step--thank-you').addClass('stages__steps__step--selected');
    checkCompletedSteps();
}

function ajaxFormStagesCallback($form, data)
{
    if ($form.find('.stages__steps__step--selected').length > 0 && $form.parent().find('.ajax-form__errors').length > 0) {
        if (typeof data.responseJSON !== 'undefined' && typeof data.responseJSON.desiredCategoryUuids !== 'undefined') {
            $('.stages__steps__step--selected .js-btn-stages-previous').trigger('click');
        } else {
            resetSteps($form.closest('.stages'));
        }
    }
}

var $body = $('body');
var $window = $(window);
var $subnav = $('.subnav');
var hasSubnav = ($subnav.length > 0);
var minWidth = $body.hasClass('device-desktop') ? 1024 : 320;

if ($body.hasClass('sticky')) {
    if (hasSubnav) {
        $body.addClass('sticky--subnav');
    }

    $window.scroll(function() {
        var isSticky = $window.width() >= minWidth;

        if ($window.scrollTop() <= 50 || !isSticky) {
            $body.addClass('sticky--at-top').removeClass('sticky--scrolled');
        } else {
            $body.addClass('sticky--scrolled').removeClass('sticky--at-top');
        }

        if (hasSubnav) {
            if ($window.scrollTop() <= 95 || !isSticky) {
                $body.addClass('sticky--animations-top');
                $body.removeClass('sticky--animations-scrolled');

                $subnav.removeClass('subnav--collapsed');
            } else {
                $body.removeClass('sticky--animations-top');
                $body.addClass('sticky--animations-scrolled');

                $subnav.addClass('subnav--collapsed');
            }
        }
    }).trigger('scroll');
}

$('body')
    .on('click', '.js-swap', function(e) {
        $('.js-swap-hide').hide();

        $($(this).attr('href')).show();

        e.preventDefault();
    });

;(function ($) {
    $('.tabbed-panels').each(function () {
        var $wrapper = $(this);

        $wrapper.on('click', '[data-toggle="tab"]', function (e) {
            e.preventDefault();

            if ($(this).hasClass('disabled')) {
                return;
            }

            $wrapper.find('[data-toggle="tab"]').removeClass('active').parent().removeClass('is-active');

            var $link = $(this);
            var $target = $($link.attr('href'));

            $link.addClass('active').parent().addClass('is-active');

            $wrapper.find('.tabbed-panels__pane').removeClass('active');

            $target.addClass('active');
        });
    });
})(jQuery);

$('body')
    .on('click', '.js-table-show-more-btn', function(e) {
        var $tableShowMore = $(this).closest('.table-show-more');
        var $table = $tableShowMore.find('table');
        var h = $table.height();

        if ($tableShowMore.hasClass('table-show-more--show-less')) {
            $tableShowMore.find('.js-table-show-more-btn').hide();
            $tableShowMore.find('.js-table-show-less-btn').show();
            $tableShowMore.addClass('table-show-more--open');

            h += $('.table-show-more__footer').outerHeight();
        } else {
            $tableShowMore.find('.table-show-more__footer').fadeOut();
        }

        $tableShowMore.animate({'height': h}, function() {
            $tableShowMore.css('height', 'auto');
        });

        e.preventDefault();
    })
    .on('click', '.js-table-show-less-btn', function(e) {
        var $tableShowMore = $(this).closest('.table-show-more');

        $tableShowMore.find('.js-table-show-more-btn').show();
        $tableShowMore.find('.js-table-show-less-btn').hide();
        $tableShowMore.removeClass('table-show-more--open');

        $tableShowMore.animate({'height': $tableShowMore.data('height')});

        $(window).scrollTop($tableShowMore.offset().top);

        e.preventDefault();
    });

if ($('html').hasClass('lt-ie9')) {
    $('.table--stripy tr:odd, .table--stripy-reversed tr:odd').addClass('tr-odd');
    $('.table--stripy tr:even, .table--stripy-reversed tr:even').addClass('tr-even');
}

$('.tabs a').click(function(e) {
    var $link = $(this);
    var $target = $($link.attr('href'));

    if ($target.length > 0) {
        $('.tabs__selected').removeClass('tabs__selected');
        $('.tabs a[href="'+$link.attr('href')+'"]').closest('li').addClass('tabs__selected');

        $('.tab-content--open').removeClass('tab-content--open').addClass('tab-content--closed');
        $target.removeClass('tab-content--closed').addClass('tab-content--open');

        if ($link.closest('.tabs--after').length > 0) {
            $('html, body').animate({scrollTop: $target.offset().top - 100});
        }
    }

    e.preventDefault();
});

var $dropdown = false;
var $loginDropdown = $('.login-dropdown');
var $header = $('.header');

$('.js-toggle-dropdown').click(function(e) {
    var $this = $(this);
    var dropdown = $this.data('dropdown');

    $dropdown = $('.'+dropdown+'-dropdown');

    if ($dropdown.hasClass('toggle-dropdown--open')) {
        dropdownHide();
    } else {
        dropdownShow(dropdown);

        $this.addClass('active');
    }

    e.preventDefault();
});

$('.js-login-dropdown').click(function(e) {
    $loginDropdown.find('.login-dropdown__login-form').show();
    $loginDropdown.find('.login-dropdown__forgotten-password-form').hide();

    e.preventDefault();
});

$('.js-forgotten-password-dropdown').click(function(e) {
    $loginDropdown.find('.login-dropdown__login-form').hide();
    $loginDropdown.find('.login-dropdown__forgotten-password-form').show();

    e.preventDefault();
});

$(document).click(function(e) {
    if ($('.toggle-dropdown--open').length > 0) {
        var $target = $(e.target);

        if (!$target.hasClass('js-toggle-dropdown') && $target.closest('.js-toggle-dropdown').length === 0 && !$target.hasClass('toggle-dropdown') && $target.closest('.toggle-dropdown').length === 0) {
            dropdownHide();
        }
    }
});

function dropdownShow(dropdown) {
    dropdownHide();

    $dropdown.addClass('toggle-dropdown--open');
    $('body').addClass('toggle-dropdown--opened');

    if (dropdown === 'login') {
        $dropdown.find('.login-dropdown__login-form').show();
        $dropdown.find('.login-dropdown__forgotten-password-form').hide();
    }

    if ($('body').hasClass('device-desktop')) {
        $dropdown.find('input[type!="hidden"]:first').focus();
    }

    if ($('.wrapper--no-top-nav').length > 0) {
        setSolidHeader();
    }
}

function dropdownHide() {
    $('.toggle-dropdown--open').removeClass('toggle-dropdown--open');
    $('.toggle-dropdown--opened').removeClass('toggle-dropdown--opened');
    $('.js-toggle-dropdown.active').removeClass('active');

    removeSolidHeader();
}

function setSolidHeader() {
    $header.addClass('header--solid');
}

function removeSolidHeader() {
    $header.removeClass('header--solid');
}

var $body = $('body');
var isMobile = $body.hasClass('device-mobile') || $('body').hasClass('device-tablet');

$body.on('click', '.tooltip-click', createTooltip);

if (isMobile) {
    $body.on('click', '.tooltip', createTooltip);
} else {
    $body.on('mouseenter', '.tooltip', createTooltip);
    $body.on('mouseleave', '.tooltip', function() {
        $('.tooltip__bubble').remove();
    });
}

$(document).click(function(e) {
    var $target = $(e.target);
    if (
        !$target.hasClass('tooltip') && !$target.parent().hasClass('tooltip') &&
        !$target.hasClass('tooltip-click') &&!$target.parent().hasClass('tooltip-click') &&
        !$target.hasClass('tooltip__bubble') &&
        $target.closest('.tooltip__bubble').length === 0
    ) {
        destroyTooltip();
    }
});

$(window).resize(destroyTooltip);

function createTooltip() {
    $('.tooltip__bubble').remove();

    var $tooltip = $(this);
    var offset = $tooltip.offset();
    var position = $tooltip.data('position');
    var arrowPosition = '';
    var css = {};
    var text = $tooltip.data('text');
    var align = $tooltip.data('align');
    var bubbleClass = $tooltip.data('tooltip-bubble-class');

    if (typeof window[$tooltip.data('text-callback')] === 'function') {
        text = window[$tooltip.data('text-callback')]($tooltip);
    }

    if (typeof text == 'undefined' || $.trim(text) == '') {
        return false;
    }

    if (text.substr(0, 4) == 'http') {
        return openModal(text);
    }

    $('body').append('<div class="tooltip__bubble"></div>');

    var $bubble = $('.tooltip__bubble').html('<div class="tooltip__bubble__triangle"></div><div class="tooltip__bubble__text">'+text+'</div>');

    if (text.length > 100) {
        $bubble.addClass('tooltip__bubble--large');
    } else {
        var $text = $bubble.find('.tooltip__bubble__text');
        var w = $text.css('display', 'inline-block').width();

        if (w < $bubble.width()) {
            $bubble.width(w + 3);
        }
    }

    if (typeof bubbleClass != 'undefined') {
        $bubble.addClass(bubbleClass);
    }

    if (position === 'top') {
        arrowPosition = 'bottom';
        css.top = offset.top - $bubble.outerHeight();
        css.left = (offset.left + ($tooltip.outerWidth() / 2)) - ($bubble.outerWidth() / 2);
    } else if (position === 'right') {
        arrowPosition = 'left';
        css.top = (offset.top + ($tooltip.outerHeight() / 2)) - ($bubble.outerHeight() / 2);
        css.left = offset.left + $tooltip.outerWidth();
    } else if (position === 'bottom') {
        arrowPosition = 'top';
        css.top = offset.top + $tooltip.outerHeight();
        css.left = (offset.left + ($tooltip.outerWidth() / 2)) - ($bubble.outerWidth() / 2);
    } else if (position === 'left') {
        arrowPosition = 'right';
        css.top = (offset.top + ($tooltip.outerHeight() / 2)) - ($bubble.outerHeight() / 2);
        css.left = offset.left - $bubble.outerWidth();
    }

    if (css.left < 0) {
        css.left = 10;

        if ($bubble.hasClass('tooltip__bubble--overwrite-hard-left')) {
            css.left = $tooltip.offset().left;
        }

        $bubble.addClass('tooltip__bubble--hard-left');
    }

    if (align == 'left') {
        css.left = offset.left;
    } else if (align == 'left-desktop-tablet' && ($('body').hasClass('device-desktop') || $('body').hasClass('device-tablet'))) {
        css.left = offset.left;
    }

    $bubble.addClass('tooltip__bubble--arrow-'+arrowPosition).css(css);

    var diff = ($bubble.outerWidth() + $bubble.offset().left) - $('.wrapper').width();

    if (diff > 0) {
        $bubble.css('margin-left', '-'+(diff + 10)+'px');
        $bubble.addClass('tooltip__bubble--hard-right');
    }
}

function destroyTooltip() {
    $('.tooltip__bubble').remove();
}

$('body').on('change', '.validate-telephone', function() {
    $(this).removeClass('valid-telephone');
});

jQuery.validator.addMethod('validate-telephone', function(value, element) {
    var isValid = true;
    var check = true;
    var isOptional = this.optional(element);
    var $input = $(element);
    var $error = $input.closest('.form-row').find('.msg-error');
    var $focused = $(':focus');

    if ($error.length > 0) {
        $error.remove();
    }

    if (isOptional && $.trim(value) == '') {
        check = false;
    } else if ($input.is(':focus')) {
        check = false;
    } else if ($input.hasClass('validating')) {
        check = false;
    } else if ($input.hasClass('valid-telephone')) {
        check = false;
    }

    if ($input.hasClass('required') && $input.hasClass('error') && $.trim(value) == '') {
        isValid = false;
        check = false;
    }

    if (check) {
        $input.addClass('validating');

        $.ajax({
            url: $input.hasClass('validate-mobile') ? '/validate/mobile' : '/validate/telephone',
            method: 'POST',
            async: false,
            data: {
                telephone: $input.val()
            }
        }).fail(function () {
            isValid = false;
        }).always(function() {
            $input.removeClass('validating');
        });
    }

    var result = isOptional || isValid;

    if (result) {
        $input.addClass('valid-telephone');
    } else {
        $input.removeClass('valid-telephone');
    }

    return result;
}, 'The telephone format is invalid.');

//# sourceMappingURL=app.main.js.map
